/**
 * Generated by @openapi-codegen
 *
 * @version 1.0
 */
import * as reactQuery from '@tanstack/react-query';
import { useOpenapiContext, OpenapiContext } from './openapiContext';
import type * as Fetcher from './openapiFetcher';
import { openapiFetch } from './openapiFetcher';
import type * as Schemas from './openapiSchemas';
import type { ClientErrorStatus, ServerErrorStatus } from './openapiUtils';

export type IsHealthyError = Fetcher.ErrorWrapper<undefined>;

export type IsHealthyVariables = OpenapiContext['fetcherOptions'];

export const fetchIsHealthy = (
  variables: IsHealthyVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, IsHealthyError, undefined, {}, {}, {}>({
    url: '/health/ishealthy',
    method: 'get',
    ...variables,
    signal,
  });

export const useIsHealthy = <TData = undefined>(
  variables: IsHealthyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, IsHealthyError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, IsHealthyError, TData>(
    queryKeyFn({
      path: '/health/ishealthy',
      operationId: 'isHealthy',
      variables,
    }),
    ({ signal }) => fetchIsHealthy({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type WorkspaceCreateForOrganizationPathParams = {
  organizationId: string;
};

export type WorkspaceCreateForOrganizationError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.WorkspaceResponse;
}>;

export type WorkspaceCreateForOrganizationVariables = {
  body: Schemas.WorkspaceCreateRequest;
  pathParams: WorkspaceCreateForOrganizationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchWorkspaceCreateForOrganization = (
  variables: WorkspaceCreateForOrganizationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    WorkspaceCreateForOrganizationError,
    Schemas.WorkspaceCreateRequest,
    {},
    {},
    WorkspaceCreateForOrganizationPathParams
  >({
    url: '/workspaces/organizations/{organizationId}',
    method: 'post',
    ...variables,
    signal,
  });

export const useWorkspaceCreateForOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      WorkspaceCreateForOrganizationError,
      WorkspaceCreateForOrganizationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    WorkspaceCreateForOrganizationError,
    WorkspaceCreateForOrganizationVariables
  >(
    (variables: WorkspaceCreateForOrganizationVariables) =>
      fetchWorkspaceCreateForOrganization({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type WorkspaceEditPathParams = {
  id: string;
};

export type WorkspaceEditError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.WorkspaceResponse;
}>;

export type WorkspaceEditVariables = {
  body: Schemas.WorkspaceEditRequest;
  pathParams: WorkspaceEditPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchWorkspaceEdit = (
  variables: WorkspaceEditVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    WorkspaceEditError,
    Schemas.WorkspaceEditRequest,
    {},
    {},
    WorkspaceEditPathParams
  >({ url: '/workspaces/{id}', method: 'put', ...variables, signal });

export const useWorkspaceEdit = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      WorkspaceEditError,
      WorkspaceEditVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    WorkspaceEditError,
    WorkspaceEditVariables
  >(
    (variables: WorkspaceEditVariables) =>
      fetchWorkspaceEdit({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteWorkspacePathParams = {
  id: string;
};

export type DeleteWorkspaceError = Fetcher.ErrorWrapper<undefined>;

export type DeleteWorkspaceVariables = {
  pathParams: DeleteWorkspacePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteWorkspace = (
  variables: DeleteWorkspaceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteWorkspaceError,
    undefined,
    {},
    {},
    DeleteWorkspacePathParams
  >({ url: '/workspaces/{id}', method: 'delete', ...variables, signal });

export const useDeleteWorkspace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteWorkspaceError,
      DeleteWorkspaceVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteWorkspaceError,
    DeleteWorkspaceVariables
  >(
    (variables: DeleteWorkspaceVariables) =>
      fetchDeleteWorkspace({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type WorkspaceDetailsPathParams = {
  id: string;
};

export type WorkspaceDetailsError = Fetcher.ErrorWrapper<undefined>;

export type WorkspaceDetailsVariables = {
  pathParams: WorkspaceDetailsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchWorkspaceDetails = (
  variables: WorkspaceDetailsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.WorkspaceResponse,
    WorkspaceDetailsError,
    undefined,
    {},
    {},
    WorkspaceDetailsPathParams
  >({ url: '/workspaces/{id}', method: 'get', ...variables, signal });

export const useWorkspaceDetails = <TData = Schemas.WorkspaceResponse>(
  variables: WorkspaceDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.WorkspaceResponse,
      WorkspaceDetailsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.WorkspaceResponse,
    WorkspaceDetailsError,
    TData
  >(
    queryKeyFn({
      path: '/workspaces/{id}',
      operationId: 'workspaceDetails',
      variables,
    }),
    ({ signal }) =>
      fetchWorkspaceDetails({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type LeaveWorkspacePathParams = {
  workspaceId: string;
};

export type LeaveWorkspaceError = Fetcher.ErrorWrapper<undefined>;

export type LeaveWorkspaceVariables = {
  pathParams: LeaveWorkspacePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchLeaveWorkspace = (
  variables: LeaveWorkspaceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    LeaveWorkspaceError,
    undefined,
    {},
    {},
    LeaveWorkspacePathParams
  >({
    url: '/workspaces/{workspaceId}/leave',
    method: 'put',
    ...variables,
    signal,
  });

export const useLeaveWorkspace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      LeaveWorkspaceError,
      LeaveWorkspaceVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    LeaveWorkspaceError,
    LeaveWorkspaceVariables
  >(
    (variables: LeaveWorkspaceVariables) =>
      fetchLeaveWorkspace({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RemoveFromWorkspacePathParams = {
  workspaceId: string;
  userId: string;
};

export type RemoveFromWorkspaceError = Fetcher.ErrorWrapper<undefined>;

export type RemoveFromWorkspaceVariables = {
  pathParams: RemoveFromWorkspacePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRemoveFromWorkspace = (
  variables: RemoveFromWorkspaceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RemoveFromWorkspaceError,
    undefined,
    {},
    {},
    RemoveFromWorkspacePathParams
  >({
    url: '/workspaces/{workspaceId}/users/{userId}/remove',
    method: 'delete',
    ...variables,
    signal,
  });

export const useRemoveFromWorkspace = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveFromWorkspaceError,
      RemoveFromWorkspaceVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveFromWorkspaceError,
    RemoveFromWorkspaceVariables
  >(
    (variables: RemoveFromWorkspaceVariables) =>
      fetchRemoveFromWorkspace({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetWorkspaceMembersPathParams = {
  workspaceId: string;
};

export type GetWorkspaceMembersQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetWorkspaceMembersError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.WorkspaceMemberResponse;
}>;

export type GetWorkspaceMembersResponse = {
  data: Schemas.WorkspaceMemberResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetWorkspaceMembersVariables = {
  pathParams: GetWorkspaceMembersPathParams;
  queryParams?: GetWorkspaceMembersQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetWorkspaceMembers = (
  variables: GetWorkspaceMembersVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetWorkspaceMembersResponse,
    GetWorkspaceMembersError,
    undefined,
    {},
    GetWorkspaceMembersQueryParams,
    GetWorkspaceMembersPathParams
  >({
    url: '/workspaces/{workspaceId}/members',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetWorkspaceMembers = <TData = GetWorkspaceMembersResponse>(
  variables: GetWorkspaceMembersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetWorkspaceMembersResponse,
      GetWorkspaceMembersError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetWorkspaceMembersResponse,
    GetWorkspaceMembersError,
    TData
  >(
    queryKeyFn({
      path: '/workspaces/{workspaceId}/members',
      operationId: 'getWorkspaceMembers',
      variables,
    }),
    ({ signal }) =>
      fetchGetWorkspaceMembers({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetWorkspacesQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetWorkspacesError = Fetcher.ErrorWrapper<undefined>;

export type GetWorkspacesResponse = {
  data: Schemas.WorkspaceResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetWorkspacesVariables = {
  queryParams?: GetWorkspacesQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetWorkspaces = (
  variables: GetWorkspacesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetWorkspacesResponse,
    GetWorkspacesError,
    undefined,
    {},
    GetWorkspacesQueryParams,
    {}
  >({ url: '/workspaces', method: 'get', ...variables, signal });

export const useGetWorkspaces = <TData = GetWorkspacesResponse>(
  variables: GetWorkspacesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetWorkspacesResponse,
      GetWorkspacesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<GetWorkspacesResponse, GetWorkspacesError, TData>(
    queryKeyFn({
      path: '/workspaces',
      operationId: 'getWorkspaces',
      variables,
    }),
    ({ signal }) =>
      fetchGetWorkspaces({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type InviteMemberPathParams = {
  workspaceId: string;
};

export type InviteMemberError = Fetcher.ErrorWrapper<undefined>;

export type InviteMemberVariables = {
  body: Schemas.InviteMemberRequest;
  pathParams: InviteMemberPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchInviteMember = (
  variables: InviteMemberVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    InviteMemberError,
    Schemas.InviteMemberRequest,
    {},
    {},
    InviteMemberPathParams
  >({
    url: '/workspaces/{workspaceId}/invite',
    method: 'post',
    ...variables,
    signal,
  });

export const useInviteMember = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      InviteMemberError,
      InviteMemberVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    InviteMemberError,
    InviteMemberVariables
  >(
    (variables: InviteMemberVariables) =>
      fetchInviteMember({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetInvitationsPathParams = {
  workspaceId: string;
};

export type GetInvitationsQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetInvitationsError = Fetcher.ErrorWrapper<undefined>;

export type GetInvitationsResponse = {
  data: Schemas.InvitationResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetInvitationsVariables = {
  pathParams: GetInvitationsPathParams;
  queryParams?: GetInvitationsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetInvitations = (
  variables: GetInvitationsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetInvitationsResponse,
    GetInvitationsError,
    undefined,
    {},
    GetInvitationsQueryParams,
    GetInvitationsPathParams
  >({
    url: '/workspaces/{workspaceId}/invitations/invitations',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetInvitations = <TData = GetInvitationsResponse>(
  variables: GetInvitationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetInvitationsResponse,
      GetInvitationsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetInvitationsResponse,
    GetInvitationsError,
    TData
  >(
    queryKeyFn({
      path: '/workspaces/{workspaceId}/invitations/invitations',
      operationId: 'getInvitations',
      variables,
    }),
    ({ signal }) =>
      fetchGetInvitations({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type RemoveInvitationPathParams = {
  invitationId: string;
  workspaceId: string;
};

export type RemoveInvitationError = Fetcher.ErrorWrapper<undefined>;

export type RemoveInvitationVariables = {
  pathParams: RemoveInvitationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRemoveInvitation = (
  variables: RemoveInvitationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RemoveInvitationError,
    undefined,
    {},
    {},
    RemoveInvitationPathParams
  >({
    url: '/workspaces/{workspaceId}/invitations/{invitationId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useRemoveInvitation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveInvitationError,
      RemoveInvitationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveInvitationError,
    RemoveInvitationVariables
  >(
    (variables: RemoveInvitationVariables) =>
      fetchRemoveInvitation({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type UpdateInvitationPathParams = {
  invitationId: string;
  workspaceId: string;
};

export type UpdateInvitationError = Fetcher.ErrorWrapper<undefined>;

export type UpdateInvitationVariables = {
  body: Schemas.UpdateInvitationRequest;
  pathParams: UpdateInvitationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateInvitation = (
  variables: UpdateInvitationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateInvitationError,
    Schemas.UpdateInvitationRequest,
    {},
    {},
    UpdateInvitationPathParams
  >({
    url: '/workspaces/{workspaceId}/invitations/{invitationId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useUpdateInvitation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateInvitationError,
      UpdateInvitationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateInvitationError,
    UpdateInvitationVariables
  >(
    (variables: UpdateInvitationVariables) =>
      fetchUpdateInvitation({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetInvitationDetailsQueryParams = {
  token: string;
};

export type GetInvitationDetailsError = Fetcher.ErrorWrapper<undefined>;

export type GetInvitationDetailsVariables = {
  queryParams: GetInvitationDetailsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetInvitationDetails = (
  variables: GetInvitationDetailsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetInvitationDetailsError,
    undefined,
    {},
    GetInvitationDetailsQueryParams,
    {}
  >({ url: '/invitations/details', method: 'get', ...variables, signal });

export const useGetInvitationDetails = <TData = undefined>(
  variables: GetInvitationDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetInvitationDetailsError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetInvitationDetailsError, TData>(
    queryKeyFn({
      path: '/invitations/details',
      operationId: 'getInvitationDetails',
      variables,
    }),
    ({ signal }) =>
      fetchGetInvitationDetails({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type PublicSearchQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  query?: string;
  organizationId?: string;
};

export type PublicSearchError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.ProcSearchResponse;
}>;

export type PublicSearchResponse = {
  data: Schemas.ProcSearchResponse[];
  meta: Schemas.PageMetaResponse;
};

export type PublicSearchVariables = {
  queryParams?: PublicSearchQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchPublicSearch = (
  variables: PublicSearchVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    PublicSearchResponse,
    PublicSearchError,
    undefined,
    {},
    PublicSearchQueryParams,
    {}
  >({ url: '/public/search', method: 'get', ...variables, signal });

export const usePublicSearch = <TData = PublicSearchResponse>(
  variables: PublicSearchVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<PublicSearchResponse, PublicSearchError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<PublicSearchResponse, PublicSearchError, TData>(
    queryKeyFn({
      path: '/public/search',
      operationId: 'publicSearch',
      variables,
    }),
    ({ signal }) =>
      fetchPublicSearch({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ProcDuplicatePathParams = {
  id: string;
};

export type ProcDuplicateQueryParams = {
  linkToBase: boolean;
};

export type ProcDuplicateError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcDuplicateVariables = {
  pathParams: ProcDuplicatePathParams;
  queryParams: ProcDuplicateQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcDuplicate = (
  variables: ProcDuplicateVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ProcDetailsResponse,
    ProcDuplicateError,
    undefined,
    {},
    ProcDuplicateQueryParams,
    ProcDuplicatePathParams
  >({ url: '/procs/duplicate/{id}', method: 'put', ...variables, signal });

export const useProcDuplicate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ProcDetailsResponse,
      ProcDuplicateError,
      ProcDuplicateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.ProcDetailsResponse,
    ProcDuplicateError,
    ProcDuplicateVariables
  >(
    (variables: ProcDuplicateVariables) =>
      fetchProcDuplicate({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcCreateError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 201>;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcCreateVariables = {
  body: Schemas.AuthorProcCreateRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchProcCreate = (
  variables: ProcCreateVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ProcDetailsResponse,
    ProcCreateError,
    Schemas.AuthorProcCreateRequest,
    {},
    {},
    {}
  >({ url: '/procs', method: 'post', ...variables, signal });

export const useProcCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ProcDetailsResponse,
      ProcCreateError,
      ProcCreateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.ProcDetailsResponse,
    ProcCreateError,
    ProcCreateVariables
  >(
    (variables: ProcCreateVariables) =>
      fetchProcCreate({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcCreateSimpleError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcCreateSimpleVariables = {
  body: Schemas.AuthorProcSimpleCreateRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchProcCreateSimple = (
  variables: ProcCreateSimpleVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcCreateSimpleError,
    Schemas.AuthorProcSimpleCreateRequest,
    {},
    {},
    {}
  >({ url: '/procs/simple', method: 'post', ...variables, signal });

export const useProcCreateSimple = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcCreateSimpleError,
      ProcCreateSimpleVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcCreateSimpleError,
    ProcCreateSimpleVariables
  >(
    (variables: ProcCreateSimpleVariables) =>
      fetchProcCreateSimple({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcActionsPathParams = {
  id: string;
};

export type ProcActionsError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcActionsVariables = {
  body?: Schemas.AuthorProcActionsRequest;
  pathParams: ProcActionsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcActions = (
  variables: ProcActionsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcActionsError,
    Schemas.AuthorProcActionsRequest,
    {},
    {},
    ProcActionsPathParams
  >({ url: '/procs/{id}/actions', method: 'patch', ...variables, signal });

export const useProcActions = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcActionsError,
      ProcActionsVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcActionsError,
    ProcActionsVariables
  >(
    (variables: ProcActionsVariables) =>
      fetchProcActions({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcEditPathParams = {
  id: string;
};

export type ProcEditError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcEditVariables = {
  body: Schemas.AuthorProcEditRequest;
  pathParams: ProcEditPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcEdit = (
  variables: ProcEditVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcEditError,
    Schemas.AuthorProcEditRequest,
    {},
    {},
    ProcEditPathParams
  >({ url: '/procs/{id}', method: 'put', ...variables, signal });

export const useProcEdit = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ProcEditError, ProcEditVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<undefined, ProcEditError, ProcEditVariables>(
    (variables: ProcEditVariables) =>
      fetchProcEdit({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcPatchDetailsEditPathParams = {
  id: string;
};

export type ProcPatchDetailsEditError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcPatchDetailsEditVariables = {
  body?: Schemas.AuthorProcPatchRequest;
  pathParams: ProcPatchDetailsEditPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcPatchDetailsEdit = (
  variables: ProcPatchDetailsEditVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcPatchDetailsEditError,
    Schemas.AuthorProcPatchRequest,
    {},
    {},
    ProcPatchDetailsEditPathParams
  >({ url: '/procs/{id}', method: 'patch', ...variables, signal });

export const useProcPatchDetailsEdit = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcPatchDetailsEditError,
      ProcPatchDetailsEditVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcPatchDetailsEditError,
    ProcPatchDetailsEditVariables
  >(
    (variables: ProcPatchDetailsEditVariables) =>
      fetchProcPatchDetailsEdit({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcDetailsPathParams = {
  id: string;
};

export type ProcDetailsError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcDetailsVariables = {
  pathParams: ProcDetailsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcDetails = (
  variables: ProcDetailsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcDetailsError,
    undefined,
    {},
    {},
    ProcDetailsPathParams
  >({ url: '/procs/{id}', method: 'get', ...variables, signal });

export const useProcDetails = <TData = undefined>(
  variables: ProcDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ProcDetailsError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, ProcDetailsError, TData>(
    queryKeyFn({ path: '/procs/{id}', operationId: 'procDetails', variables }),
    ({ signal }) =>
      fetchProcDetails({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ProcDeletePathParams = {
  id: string;
};

export type ProcDeleteError = Fetcher.ErrorWrapper<undefined>;

export type ProcDeleteVariables = {
  pathParams: ProcDeletePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcDelete = (
  variables: ProcDeleteVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcDeleteError,
    undefined,
    {},
    {},
    ProcDeletePathParams
  >({ url: '/procs/{id}', method: 'delete', ...variables, signal });

export const useProcDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcDeleteError,
      ProcDeleteVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcDeleteError,
    ProcDeleteVariables
  >(
    (variables: ProcDeleteVariables) =>
      fetchProcDelete({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcPublishPathParams = {
  id: string;
};

export type ProcPublishError = Fetcher.ErrorWrapper<undefined>;

export type ProcPublishVariables = {
  body: Schemas.AuthorProcPublishRequest;
  pathParams: ProcPublishPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcPublish = (
  variables: ProcPublishVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcPublishError,
    Schemas.AuthorProcPublishRequest,
    {},
    {},
    ProcPublishPathParams
  >({ url: '/procs/{id}/publish', method: 'put', ...variables, signal });

export const useProcPublish = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcPublishError,
      ProcPublishVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcPublishError,
    ProcPublishVariables
  >(
    (variables: ProcPublishVariables) =>
      fetchProcPublish({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcUnpublishPathParams = {
  id: string;
};

export type ProcUnpublishError = Fetcher.ErrorWrapper<undefined>;

export type ProcUnpublishVariables = {
  pathParams: ProcUnpublishPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcUnpublish = (
  variables: ProcUnpublishVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcUnpublishError,
    undefined,
    {},
    {},
    ProcUnpublishPathParams
  >({ url: '/procs/{id}/unpublish', method: 'put', ...variables, signal });

export const useProcUnpublish = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcUnpublishError,
      ProcUnpublishVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcUnpublishError,
    ProcUnpublishVariables
  >(
    (variables: ProcUnpublishVariables) =>
      fetchProcUnpublish({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcPublicDetailsPathParams = {
  id: string;
};

export type ProcPublicDetailsError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type ProcPublicDetailsVariables = {
  pathParams: ProcPublicDetailsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcPublicDetails = (
  variables: ProcPublicDetailsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcPublicDetailsError,
    undefined,
    {},
    {},
    ProcPublicDetailsPathParams
  >({ url: '/public/procs/{id}', method: 'get', ...variables, signal });

export const useProcPublicDetails = <TData = undefined>(
  variables: ProcPublicDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ProcPublicDetailsError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, ProcPublicDetailsError, TData>(
    queryKeyFn({
      path: '/public/procs/{id}',
      operationId: 'procPublicDetails',
      variables,
    }),
    ({ signal }) =>
      fetchProcPublicDetails({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type AddNewStepPathParams = {
  id: string;
};

export type AddNewStepError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type AddNewStepVariables = {
  body: Schemas.StepCreateRequest;
  pathParams: AddNewStepPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchAddNewStep = (
  variables: AddNewStepVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    AddNewStepError,
    Schemas.StepCreateRequest,
    {},
    {},
    AddNewStepPathParams
  >({ url: '/procs/{id}/steps', method: 'post', ...variables, signal });

export const useAddNewStep = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AddNewStepError,
      AddNewStepVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    AddNewStepError,
    AddNewStepVariables
  >(
    (variables: AddNewStepVariables) =>
      fetchAddNewStep({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type StepRemovePathParams = {
  id: string;
  stepId: string;
};

export type StepRemoveError = Fetcher.ErrorWrapper<undefined>;

export type StepRemoveVariables = {
  pathParams: StepRemovePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchStepRemove = (
  variables: StepRemoveVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    StepRemoveError,
    undefined,
    {},
    {},
    StepRemovePathParams
  >({
    url: '/procs/{id}/steps/{stepId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useStepRemove = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      StepRemoveError,
      StepRemoveVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    StepRemoveError,
    StepRemoveVariables
  >(
    (variables: StepRemoveVariables) =>
      fetchStepRemove({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type UpdateStepPathParams = {
  id: string;
  stepId: string;
};

export type UpdateStepError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type UpdateStepVariables = {
  body?: Schemas.StepUpdateRequest;
  pathParams: UpdateStepPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateStep = (
  variables: UpdateStepVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateStepError,
    Schemas.StepUpdateRequest,
    {},
    {},
    UpdateStepPathParams
  >({
    url: '/procs/{id}/steps/{stepId}',
    method: 'patch',
    ...variables,
    signal,
  });

export const useUpdateStep = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateStepError,
      UpdateStepVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateStepError,
    UpdateStepVariables
  >(
    (variables: UpdateStepVariables) =>
      fetchUpdateStep({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type CreateComponentPathParams = {
  procId: string;
  stepId: string;
};

export type CreateComponentError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ComponentResponse;
}>;

export type CreateComponentVariables = {
  body: Schemas.ComponentAddRequest;
  pathParams: CreateComponentPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchCreateComponent = (
  variables: CreateComponentVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    CreateComponentError,
    Schemas.ComponentAddRequest,
    {},
    {},
    CreateComponentPathParams
  >({
    url: '/procs/{procId}/steps/{stepId}/components',
    method: 'post',
    ...variables,
    signal,
  });

export const useCreateComponent = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateComponentError,
      CreateComponentVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    CreateComponentError,
    CreateComponentVariables
  >(
    (variables: CreateComponentVariables) =>
      fetchCreateComponent({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type UpdateComponentPathParams = {
  procId: string;
  stepId: string;
};

export type UpdateComponentError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type UpdateComponentVariables = {
  body: Schemas.ComponentUpdateRequest;
  pathParams: UpdateComponentPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateComponent = (
  variables: UpdateComponentVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateComponentError,
    Schemas.ComponentUpdateRequest,
    {},
    {},
    UpdateComponentPathParams
  >({
    url: '/procs/{procId}/steps/{stepId}/components',
    method: 'put',
    ...variables,
    signal,
  });

export const useUpdateComponent = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateComponentError,
      UpdateComponentVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateComponentError,
    UpdateComponentVariables
  >(
    (variables: UpdateComponentVariables) =>
      fetchUpdateComponent({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteComponentPathParams = {
  procId: string;
  stepId: string;
  componentId: string;
};

export type DeleteComponentError = Fetcher.ErrorWrapper<undefined>;

export type DeleteComponentVariables = {
  pathParams: DeleteComponentPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteComponent = (
  variables: DeleteComponentVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteComponentError,
    undefined,
    {},
    {},
    DeleteComponentPathParams
  >({
    url: '/procs/{procId}/steps/{stepId}/components/{componentId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteComponent = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteComponentError,
      DeleteComponentVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteComponentError,
    DeleteComponentVariables
  >(
    (variables: DeleteComponentVariables) =>
      fetchDeleteComponent({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetProcsByWorkspacePathParams = {
  workspaceId: string;
};

export type GetProcsByWorkspaceQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetProcsByWorkspaceError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.PageResponse;
}>;

export type GetProcsByWorkspaceResponse = {
  data: Schemas.ProcDetailsResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetProcsByWorkspaceVariables = {
  pathParams: GetProcsByWorkspacePathParams;
  queryParams?: GetProcsByWorkspaceQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetProcsByWorkspace = (
  variables: GetProcsByWorkspaceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetProcsByWorkspaceResponse,
    GetProcsByWorkspaceError,
    undefined,
    {},
    GetProcsByWorkspaceQueryParams,
    GetProcsByWorkspacePathParams
  >({
    url: '/procs/workspaces/{workspaceId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetProcsByWorkspace = <TData = GetProcsByWorkspaceResponse>(
  variables: GetProcsByWorkspaceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetProcsByWorkspaceResponse,
      GetProcsByWorkspaceError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetProcsByWorkspaceResponse,
    GetProcsByWorkspaceError,
    TData
  >(
    queryKeyFn({
      path: '/procs/workspaces/{workspaceId}',
      operationId: 'getProcsByWorkspace',
      variables,
    }),
    ({ signal }) =>
      fetchGetProcsByWorkspace({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetOneProcInstanceAuthorViewPathParams = {
  instanceId: string;
};

export type GetOneProcInstanceAuthorViewError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.UserProcResponse;
}>;

export type GetOneProcInstanceAuthorViewVariables = {
  pathParams: GetOneProcInstanceAuthorViewPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOneProcInstanceAuthorView = (
  variables: GetOneProcInstanceAuthorViewVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetOneProcInstanceAuthorViewError,
    undefined,
    {},
    {},
    GetOneProcInstanceAuthorViewPathParams
  >({
    url: '/procs/instances/{instanceId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetOneProcInstanceAuthorView = <TData = undefined>(
  variables: GetOneProcInstanceAuthorViewVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetOneProcInstanceAuthorViewError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    undefined,
    GetOneProcInstanceAuthorViewError,
    TData
  >(
    queryKeyFn({
      path: '/procs/instances/{instanceId}',
      operationId: 'getOneProcInstanceAuthorView',
      variables,
    }),
    ({ signal }) =>
      fetchGetOneProcInstanceAuthorView(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ProcInstancesPathParams = {
  procId: string;
};

export type ProcInstancesQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type ProcInstancesError = Fetcher.ErrorWrapper<undefined>;

export type ProcInstancesResponse = {
  data: Schemas.UserProcResponse[];
  meta: Schemas.PageMetaResponse;
};

export type ProcInstancesVariables = {
  pathParams: ProcInstancesPathParams;
  queryParams?: ProcInstancesQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcInstances = (
  variables: ProcInstancesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    ProcInstancesResponse,
    ProcInstancesError,
    undefined,
    {},
    ProcInstancesQueryParams,
    ProcInstancesPathParams
  >({ url: '/procs/{procId}/instances', method: 'get', ...variables, signal });

export const useProcInstances = <TData = ProcInstancesResponse>(
  variables: ProcInstancesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ProcInstancesResponse,
      ProcInstancesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<ProcInstancesResponse, ProcInstancesError, TData>(
    queryKeyFn({
      path: '/procs/{procId}/instances',
      operationId: 'procInstances',
      variables,
    }),
    ({ signal }) =>
      fetchProcInstances({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetProcInstancePathParams = {
  instanceId: string;
};

export type GetProcInstanceError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.UserProcResponse;
}>;

export type GetProcInstanceVariables = {
  pathParams: GetProcInstancePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetProcInstance = (
  variables: GetProcInstanceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetProcInstanceError,
    undefined,
    {},
    {},
    GetProcInstancePathParams
  >({
    url: '/procs/author/instances/{instanceId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetProcInstance = <TData = undefined>(
  variables: GetProcInstanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetProcInstanceError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetProcInstanceError, TData>(
    queryKeyFn({
      path: '/procs/author/instances/{instanceId}',
      operationId: 'getProcInstance',
      variables,
    }),
    ({ signal }) =>
      fetchGetProcInstance({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type DeleteProcInstancePathParams = {
  id: string;
  instanceId: string;
};

export type DeleteProcInstanceError = Fetcher.ErrorWrapper<undefined>;

export type DeleteProcInstanceVariables = {
  pathParams: DeleteProcInstancePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteProcInstance = (
  variables: DeleteProcInstanceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteProcInstanceError,
    undefined,
    {},
    {},
    DeleteProcInstancePathParams
  >({
    url: '/procs/author/{id}/instances/{instanceId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteProcInstance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteProcInstanceError,
      DeleteProcInstanceVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteProcInstanceError,
    DeleteProcInstanceVariables
  >(
    (variables: DeleteProcInstanceVariables) =>
      fetchDeleteProcInstance({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type AdministrateUserProcPathParams = {
  id: string;
  instanceId: string;
};

export type AdministrateUserProcError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.UserProcResponse;
}>;

export type AdministrateUserProcVariables = {
  body?: Schemas.AdministrateProcInstanceRequest;
  pathParams: AdministrateUserProcPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchAdministrateUserProc = (
  variables: AdministrateUserProcVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    AdministrateUserProcError,
    Schemas.AdministrateProcInstanceRequest,
    {},
    {},
    AdministrateUserProcPathParams
  >({
    url: '/procs/author/{id}/instances/{instanceId}',
    method: 'patch',
    ...variables,
    signal,
  });

export const useAdministrateUserProc = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AdministrateUserProcError,
      AdministrateUserProcVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    AdministrateUserProcError,
    AdministrateUserProcVariables
  >(
    (variables: AdministrateUserProcVariables) =>
      fetchAdministrateUserProc({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type UploadFilePathParams = {
  procId: string;
};

export type UploadFileError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.FileUploadResponse;
}>;

export type UploadFileVariables = {
  pathParams: UploadFilePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUploadFile = (
  variables: UploadFileVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UploadFileError,
    undefined,
    {},
    {},
    UploadFilePathParams
  >({
    url: '/procs/{procId}/file-upload',
    method: 'post',
    ...variables,
    signal,
  });

export const useUploadFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UploadFileError,
      UploadFileVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UploadFileError,
    UploadFileVariables
  >(
    (variables: UploadFileVariables) =>
      fetchUploadFile({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DuplicateStepPathParams = {
  id: string;
  stepId: string;
};

export type DuplicateStepError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type DuplicateStepVariables = {
  pathParams: DuplicateStepPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDuplicateStep = (
  variables: DuplicateStepVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DuplicateStepError,
    undefined,
    {},
    {},
    DuplicateStepPathParams
  >({
    url: '/procs/{id}/steps/{stepId}/duplicate',
    method: 'put',
    ...variables,
    signal,
  });

export const useDuplicateStep = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DuplicateStepError,
      DuplicateStepVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DuplicateStepError,
    DuplicateStepVariables
  >(
    (variables: DuplicateStepVariables) =>
      fetchDuplicateStep({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetInstancesForCurrentUserQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetInstancesForCurrentUserError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.UserProcResponse;
}>;

export type GetInstancesForCurrentUserResponse = {
  data: Schemas.UserProcResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetInstancesForCurrentUserVariables = {
  queryParams?: GetInstancesForCurrentUserQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetInstancesForCurrentUser = (
  variables: GetInstancesForCurrentUserVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetInstancesForCurrentUserResponse,
    GetInstancesForCurrentUserError,
    undefined,
    {},
    GetInstancesForCurrentUserQueryParams,
    {}
  >({ url: '/procs/instances/list/my', method: 'get', ...variables, signal });

export const useGetInstancesForCurrentUser = <
  TData = GetInstancesForCurrentUserResponse,
>(
  variables: GetInstancesForCurrentUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetInstancesForCurrentUserResponse,
      GetInstancesForCurrentUserError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetInstancesForCurrentUserResponse,
    GetInstancesForCurrentUserError,
    TData
  >(
    queryKeyFn({
      path: '/procs/instances/list/my',
      operationId: 'getInstancesForCurrentUser',
      variables,
    }),
    ({ signal }) =>
      fetchGetInstancesForCurrentUser(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type DetailsPathParams = {
  id: string;
  procType: string;
};

export type DetailsError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.ProcDetailsResponse;
}>;

export type DetailsVariables = {
  pathParams: DetailsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDetails = (
  variables: DetailsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, DetailsError, undefined, {}, {}, DetailsPathParams>({
    url: '/procs/type/{procType}/{id}',
    method: 'get',
    ...variables,
    signal,
  });

export const useDetails = <TData = undefined>(
  variables: DetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, DetailsError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, DetailsError, TData>(
    queryKeyFn({
      path: '/procs/type/{procType}/{id}',
      operationId: 'details',
      variables,
    }),
    ({ signal }) => fetchDetails({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ProcInstanceDetailsPathParams = {
  id: string;
};

export type ProcInstanceDetailsQueryParams = {
  code?: string;
};

export type ProcInstanceDetailsError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.UserProcResponse;
}>;

export type ProcInstanceDetailsVariables = {
  pathParams: ProcInstanceDetailsPathParams;
  queryParams?: ProcInstanceDetailsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcInstanceDetails = (
  variables: ProcInstanceDetailsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.UserProcResponse,
    ProcInstanceDetailsError,
    undefined,
    {},
    ProcInstanceDetailsQueryParams,
    ProcInstanceDetailsPathParams
  >({ url: '/instances/{id}', method: 'get', ...variables, signal });

export const useProcInstanceDetails = <TData = Schemas.UserProcResponse>(
  variables: ProcInstanceDetailsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserProcResponse,
      ProcInstanceDetailsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.UserProcResponse,
    ProcInstanceDetailsError,
    TData
  >(
    queryKeyFn({
      path: '/instances/{id}',
      operationId: 'procInstanceDetails',
      variables,
    }),
    ({ signal }) =>
      fetchProcInstanceDetails({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ProcInstantiatePathParams = {
  id: string;
};

export type ProcInstantiateError = Fetcher.ErrorWrapper<undefined>;

export type ProcInstantiateVariables = {
  body?: Schemas.UserProcInstantiateRequest;
  pathParams: ProcInstantiatePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcInstantiate = (
  variables: ProcInstantiateVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.UserProcInstantiateResponse,
    ProcInstantiateError,
    Schemas.UserProcInstantiateRequest,
    {},
    {},
    ProcInstantiatePathParams
  >({ url: '/instances/{id}', method: 'put', ...variables, signal });

export const useProcInstantiate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UserProcInstantiateResponse,
      ProcInstantiateError,
      ProcInstantiateVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.UserProcInstantiateResponse,
    ProcInstantiateError,
    ProcInstantiateVariables
  >(
    (variables: ProcInstantiateVariables) =>
      fetchProcInstantiate({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ProcComponentFillPathParams = {
  instanceId: string;
  stepId: string;
};

export type ProcComponentFillQueryParams = {
  code?: string;
};

export type ProcComponentFillError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.UserProcResponse;
}>;

export type ProcComponentFillVariables = {
  body: Schemas.FillComponentRequest;
  pathParams: ProcComponentFillPathParams;
  queryParams?: ProcComponentFillQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchProcComponentFill = (
  variables: ProcComponentFillVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ProcComponentFillError,
    Schemas.FillComponentRequest,
    {},
    ProcComponentFillQueryParams,
    ProcComponentFillPathParams
  >({
    url: '/instances/fill/{instanceId}/step/{stepId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useProcComponentFill = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProcComponentFillError,
      ProcComponentFillVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ProcComponentFillError,
    ProcComponentFillVariables
  >(
    (variables: ProcComponentFillVariables) =>
      fetchProcComponentFill({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type SetProcInstanceOwnerPathParams = {
  id: string;
};

export type SetProcInstanceOwnerError = Fetcher.ErrorWrapper<undefined>;

export type SetProcInstanceOwnerVariables = {
  body: Schemas.SendProcInstanceLinkReqDto;
  pathParams: SetProcInstanceOwnerPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchSetProcInstanceOwner = (
  variables: SetProcInstanceOwnerVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    SetProcInstanceOwnerError,
    Schemas.SendProcInstanceLinkReqDto,
    {},
    {},
    SetProcInstanceOwnerPathParams
  >({ url: '/instances/{id}/owner', method: 'put', ...variables, signal });

export const useSetProcInstanceOwner = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetProcInstanceOwnerError,
      SetProcInstanceOwnerVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    SetProcInstanceOwnerError,
    SetProcInstanceOwnerVariables
  >(
    (variables: SetProcInstanceOwnerVariables) =>
      fetchSetProcInstanceOwner({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type SubmitProcInstancePathParams = {
  id: string;
};

export type SubmitProcInstanceQueryParams = {
  code?: string;
};

export type SubmitProcInstanceError = Fetcher.ErrorWrapper<undefined>;

export type SubmitProcInstanceVariables = {
  pathParams: SubmitProcInstancePathParams;
  queryParams?: SubmitProcInstanceQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchSubmitProcInstance = (
  variables: SubmitProcInstanceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    SubmitProcInstanceError,
    undefined,
    {},
    SubmitProcInstanceQueryParams,
    SubmitProcInstancePathParams
  >({ url: '/instances/complete/{id}', method: 'put', ...variables, signal });

export const useSubmitProcInstance = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SubmitProcInstanceError,
      SubmitProcInstanceVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    SubmitProcInstanceError,
    SubmitProcInstanceVariables
  >(
    (variables: SubmitProcInstanceVariables) =>
      fetchSubmitProcInstance({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteMyUserProcPathParams = {
  id: string;
};

export type DeleteMyUserProcError = Fetcher.ErrorWrapper<undefined>;

export type DeleteMyUserProcVariables = {
  pathParams: DeleteMyUserProcPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteMyUserProc = (
  variables: DeleteMyUserProcVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteMyUserProcError,
    undefined,
    {},
    {},
    DeleteMyUserProcPathParams
  >({
    url: '/user-account/proc/instance/{id}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteMyUserProc = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteMyUserProcError,
      DeleteMyUserProcVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteMyUserProcError,
    DeleteMyUserProcVariables
  >(
    (variables: DeleteMyUserProcVariables) =>
      fetchDeleteMyUserProc({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteRulePathParams = {
  procId: string;
  stepId: string;
  logicId: string;
};

export type DeleteRuleError = Fetcher.ErrorWrapper<undefined>;

export type DeleteRuleVariables = {
  pathParams: DeleteRulePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteRule = (
  variables: DeleteRuleVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteRuleError,
    undefined,
    {},
    {},
    DeleteRulePathParams
  >({
    url: '/procs/{procId}/steps/{stepId}/logics/{logicId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteRule = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteRuleError,
      DeleteRuleVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteRuleError,
    DeleteRuleVariables
  >(
    (variables: DeleteRuleVariables) =>
      fetchDeleteRule({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetLogicsByProcIdPathParams = {
  procId: string;
};

export type GetLogicsByProcIdError = Fetcher.ErrorWrapper<undefined>;

export type GetLogicsByProcIdVariables = {
  pathParams: GetLogicsByProcIdPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetLogicsByProcId = (
  variables: GetLogicsByProcIdVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetLogicsByProcIdError,
    undefined,
    {},
    {},
    GetLogicsByProcIdPathParams
  >({ url: '/procs/{procId}/logics', method: 'get', ...variables, signal });

export const useGetLogicsByProcId = <TData = undefined>(
  variables: GetLogicsByProcIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetLogicsByProcIdError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetLogicsByProcIdError, TData>(
    queryKeyFn({
      path: '/procs/{procId}/logics',
      operationId: 'getLogicsByProcId',
      variables,
    }),
    ({ signal }) =>
      fetchGetLogicsByProcId({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UpdateStepLogicPathParams = {
  procId: string;
  stepId: string;
};

export type UpdateStepLogicError = Fetcher.ErrorWrapper<undefined>;

export type UpdateStepLogicVariables = {
  body: Schemas.UpdateStepLogic;
  pathParams: UpdateStepLogicPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateStepLogic = (
  variables: UpdateStepLogicVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateStepLogicError,
    Schemas.UpdateStepLogic,
    {},
    {},
    UpdateStepLogicPathParams
  >({
    url: '/procs/{procId}/steps/{stepId}/logics',
    method: 'patch',
    ...variables,
    signal,
  });

export const useUpdateStepLogic = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateStepLogicError,
      UpdateStepLogicVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateStepLogicError,
    UpdateStepLogicVariables
  >(
    (variables: UpdateStepLogicVariables) =>
      fetchUpdateStepLogic({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type AddLogicPathParams = {
  procId: string;
  stepId: string;
};

export type AddLogicError = Fetcher.ErrorWrapper<undefined>;

export type AddLogicVariables = {
  body: Schemas.AddLogicRequest;
  pathParams: AddLogicPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchAddLogic = (
  variables: AddLogicVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    AddLogicError,
    Schemas.AddLogicRequest,
    {},
    {},
    AddLogicPathParams
  >({
    url: '/procs/{procId}/steps/{stepId}/logic',
    method: 'post',
    ...variables,
    signal,
  });

export const useAddLogic = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, AddLogicError, AddLogicVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<undefined, AddLogicError, AddLogicVariables>(
    (variables: AddLogicVariables) =>
      fetchAddLogic({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type StartInstanceStepConversationPathParams = {
  instanceId: string;
};

export type StartInstanceStepConversationError =
  Fetcher.ErrorWrapper<undefined>;

export type StartInstanceStepConversationVariables = {
  body: Schemas.StartProcInstanceStepConversationRequest;
  pathParams: StartInstanceStepConversationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchStartInstanceStepConversation = (
  variables: StartInstanceStepConversationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    StartInstanceStepConversationError,
    Schemas.StartProcInstanceStepConversationRequest,
    {},
    {},
    StartInstanceStepConversationPathParams
  >({
    url: '/instances/{instanceId}/threads',
    method: 'post',
    ...variables,
    signal,
  });

export const useStartInstanceStepConversation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      StartInstanceStepConversationError,
      StartInstanceStepConversationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    StartInstanceStepConversationError,
    StartInstanceStepConversationVariables
  >(
    (variables: StartInstanceStepConversationVariables) =>
      fetchStartInstanceStepConversation({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetInstanceStepAiMessagesPathParams = {
  instanceId: string;
  threadId: string;
};

export type GetInstanceStepAiMessagesQueryParams = {
  procId: string;
};

export type GetInstanceStepAiMessagesError = Fetcher.ErrorWrapper<undefined>;

export type GetInstanceStepAiMessagesVariables = {
  pathParams: GetInstanceStepAiMessagesPathParams;
  queryParams: GetInstanceStepAiMessagesQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetInstanceStepAiMessages = (
  variables: GetInstanceStepAiMessagesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetInstanceStepAiMessagesError,
    undefined,
    {},
    GetInstanceStepAiMessagesQueryParams,
    GetInstanceStepAiMessagesPathParams
  >({
    url: '/instances/{instanceId}/threads/{threadId}/messages',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetInstanceStepAiMessages = <TData = undefined>(
  variables: GetInstanceStepAiMessagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetInstanceStepAiMessagesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetInstanceStepAiMessagesError, TData>(
    queryKeyFn({
      path: '/instances/{instanceId}/threads/{threadId}/messages',
      operationId: 'getInstanceStepAiMessages',
      variables,
    }),
    ({ signal }) =>
      fetchGetInstanceStepAiMessages(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type SendInstanceStepAiMessagePathParams = {
  instanceId: string;
  threadId: string;
};

export type SendInstanceStepAiMessageError = Fetcher.ErrorWrapper<undefined>;

export type SendInstanceStepAiMessageVariables = {
  body: Schemas.SendInstanceStepAiMessageRequest;
  pathParams: SendInstanceStepAiMessagePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchSendInstanceStepAiMessage = (
  variables: SendInstanceStepAiMessageVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    SendInstanceStepAiMessageError,
    Schemas.SendInstanceStepAiMessageRequest,
    {},
    {},
    SendInstanceStepAiMessagePathParams
  >({
    url: '/instances/{instanceId}/threads/{threadId}/messages',
    method: 'post',
    ...variables,
    signal,
  });

export const useSendInstanceStepAiMessage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SendInstanceStepAiMessageError,
      SendInstanceStepAiMessageVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    SendInstanceStepAiMessageError,
    SendInstanceStepAiMessageVariables
  >(
    (variables: SendInstanceStepAiMessageVariables) =>
      fetchSendInstanceStepAiMessage({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetNotificationsForInstancePathParams = {
  instanceId: string;
  viewType: string;
};

export type GetNotificationsForInstanceQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  code?: string;
};

export type GetNotificationsForInstanceError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.NotificationRecordResponse;
}>;

export type GetNotificationsForInstanceResponse = {
  data: Schemas.NotificationRecordResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetNotificationsForInstanceVariables = {
  pathParams: GetNotificationsForInstancePathParams;
  queryParams?: GetNotificationsForInstanceQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetNotificationsForInstance = (
  variables: GetNotificationsForInstanceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetNotificationsForInstanceResponse,
    GetNotificationsForInstanceError,
    undefined,
    {},
    GetNotificationsForInstanceQueryParams,
    GetNotificationsForInstancePathParams
  >({
    url: '/notifications/instances/{viewType}/{instanceId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetNotificationsForInstance = <
  TData = GetNotificationsForInstanceResponse,
>(
  variables: GetNotificationsForInstanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetNotificationsForInstanceResponse,
      GetNotificationsForInstanceError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetNotificationsForInstanceResponse,
    GetNotificationsForInstanceError,
    TData
  >(
    queryKeyFn({
      path: '/notifications/instances/{viewType}/{instanceId}',
      operationId: 'getNotificationsForInstance',
      variables,
    }),
    ({ signal }) =>
      fetchGetNotificationsForInstance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetNotificationsInfoForInstancePathParams = {
  instanceId: string;
  viewType: string;
};

export type GetNotificationsInfoForInstanceQueryParams = {
  code?: string;
};

export type GetNotificationsInfoForInstanceError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.NotificationInfoResponse;
}>;

export type GetNotificationsInfoForInstanceVariables = {
  pathParams: GetNotificationsInfoForInstancePathParams;
  queryParams?: GetNotificationsInfoForInstanceQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetNotificationsInfoForInstance = (
  variables: GetNotificationsInfoForInstanceVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetNotificationsInfoForInstanceError,
    undefined,
    {},
    GetNotificationsInfoForInstanceQueryParams,
    GetNotificationsInfoForInstancePathParams
  >({
    url: '/notifications/instance/{viewType}/{instanceId}/info',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetNotificationsInfoForInstance = <TData = undefined>(
  variables: GetNotificationsInfoForInstanceVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetNotificationsInfoForInstanceError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    undefined,
    GetNotificationsInfoForInstanceError,
    TData
  >(
    queryKeyFn({
      path: '/notifications/instance/{viewType}/{instanceId}/info',
      operationId: 'getNotificationsInfoForInstance',
      variables,
    }),
    ({ signal }) =>
      fetchGetNotificationsInfoForInstance(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetAllUserNotificationsPathParams = {
  organizationId: string;
};

export type GetAllUserNotificationsQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetAllUserNotificationsError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.NotificationRecordResponse;
}>;

export type GetAllUserNotificationsResponse = {
  data: Schemas.NotificationRecordResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetAllUserNotificationsVariables = {
  pathParams: GetAllUserNotificationsPathParams;
  queryParams?: GetAllUserNotificationsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetAllUserNotifications = (
  variables: GetAllUserNotificationsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetAllUserNotificationsResponse,
    GetAllUserNotificationsError,
    undefined,
    {},
    GetAllUserNotificationsQueryParams,
    GetAllUserNotificationsPathParams
  >({
    url: '/notifications/{organizationId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetAllUserNotifications = <
  TData = GetAllUserNotificationsResponse,
>(
  variables: GetAllUserNotificationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetAllUserNotificationsResponse,
      GetAllUserNotificationsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetAllUserNotificationsResponse,
    GetAllUserNotificationsError,
    TData
  >(
    queryKeyFn({
      path: '/notifications/{organizationId}',
      operationId: 'getAllUserNotifications',
      variables,
    }),
    ({ signal }) =>
      fetchGetAllUserNotifications({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetNotificationInfoPathParams = {
  organizationId: string;
};

export type GetNotificationInfoError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.NotificationInfoResponse;
}>;

export type GetNotificationInfoVariables = {
  pathParams: GetNotificationInfoPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetNotificationInfo = (
  variables: GetNotificationInfoVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetNotificationInfoError,
    undefined,
    {},
    {},
    GetNotificationInfoPathParams
  >({
    url: '/notifications/{organizationId}/info',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetNotificationInfo = <TData = undefined>(
  variables: GetNotificationInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetNotificationInfoError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetNotificationInfoError, TData>(
    queryKeyFn({
      path: '/notifications/{organizationId}/info',
      operationId: 'getNotificationInfo',
      variables,
    }),
    ({ signal }) =>
      fetchGetNotificationInfo({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type MarkAllNotificationsAsSeenQueryParams = {
  code?: string;
};

export type MarkAllNotificationsAsSeenError = Fetcher.ErrorWrapper<undefined>;

export type MarkAllNotificationsAsSeenVariables = {
  queryParams?: MarkAllNotificationsAsSeenQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchMarkAllNotificationsAsSeen = (
  variables: MarkAllNotificationsAsSeenVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    MarkAllNotificationsAsSeenError,
    undefined,
    {},
    MarkAllNotificationsAsSeenQueryParams,
    {}
  >({ url: '/notifications/seen', method: 'put', ...variables, signal });

export const useMarkAllNotificationsAsSeen = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      MarkAllNotificationsAsSeenError,
      MarkAllNotificationsAsSeenVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    MarkAllNotificationsAsSeenError,
    MarkAllNotificationsAsSeenVariables
  >(
    (variables: MarkAllNotificationsAsSeenVariables) =>
      fetchMarkAllNotificationsAsSeen({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type MarkInstanceNotificationsAsSeenPathParams = {
  instanceId: string;
};

export type MarkInstanceNotificationsAsSeenQueryParams = {
  code?: string;
};

export type MarkInstanceNotificationsAsSeenError =
  Fetcher.ErrorWrapper<undefined>;

export type MarkInstanceNotificationsAsSeenVariables = {
  pathParams: MarkInstanceNotificationsAsSeenPathParams;
  queryParams?: MarkInstanceNotificationsAsSeenQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchMarkInstanceNotificationsAsSeen = (
  variables: MarkInstanceNotificationsAsSeenVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    MarkInstanceNotificationsAsSeenError,
    undefined,
    {},
    MarkInstanceNotificationsAsSeenQueryParams,
    MarkInstanceNotificationsAsSeenPathParams
  >({
    url: '/notifications/seen/instance/{instanceId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useMarkInstanceNotificationsAsSeen = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      MarkInstanceNotificationsAsSeenError,
      MarkInstanceNotificationsAsSeenVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    MarkInstanceNotificationsAsSeenError,
    MarkInstanceNotificationsAsSeenVariables
  >(
    (variables: MarkInstanceNotificationsAsSeenVariables) =>
      fetchMarkInstanceNotificationsAsSeen({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type MarkNotificationAsSeenPathParams = {
  notificationId: string;
};

export type MarkNotificationAsSeenQueryParams = {
  code?: string;
};

export type MarkNotificationAsSeenError = Fetcher.ErrorWrapper<undefined>;

export type MarkNotificationAsSeenVariables = {
  pathParams: MarkNotificationAsSeenPathParams;
  queryParams?: MarkNotificationAsSeenQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchMarkNotificationAsSeen = (
  variables: MarkNotificationAsSeenVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    MarkNotificationAsSeenError,
    undefined,
    {},
    MarkNotificationAsSeenQueryParams,
    MarkNotificationAsSeenPathParams
  >({
    url: '/notifications/seen/{notificationId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useMarkNotificationAsSeen = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      MarkNotificationAsSeenError,
      MarkNotificationAsSeenVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    MarkNotificationAsSeenError,
    MarkNotificationAsSeenVariables
  >(
    (variables: MarkNotificationAsSeenVariables) =>
      fetchMarkNotificationAsSeen({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type MarkStepNotificationsAsSeenPathParams = {
  stepId: string;
  instanceId: string;
};

export type MarkStepNotificationsAsSeenQueryParams = {
  code?: string;
};

export type MarkStepNotificationsAsSeenError = Fetcher.ErrorWrapper<undefined>;

export type MarkStepNotificationsAsSeenVariables = {
  pathParams: MarkStepNotificationsAsSeenPathParams;
  queryParams?: MarkStepNotificationsAsSeenQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchMarkStepNotificationsAsSeen = (
  variables: MarkStepNotificationsAsSeenVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    MarkStepNotificationsAsSeenError,
    undefined,
    {},
    MarkStepNotificationsAsSeenQueryParams,
    MarkStepNotificationsAsSeenPathParams
  >({
    url: '/notifications/instances/{instanceId}/steps/{stepId}/seen',
    method: 'put',
    ...variables,
    signal,
  });

export const useMarkStepNotificationsAsSeen = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      MarkStepNotificationsAsSeenError,
      MarkStepNotificationsAsSeenVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    MarkStepNotificationsAsSeenError,
    MarkStepNotificationsAsSeenVariables
  >(
    (variables: MarkStepNotificationsAsSeenVariables) =>
      fetchMarkStepNotificationsAsSeen({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetPlanUsagePathParams = {
  organizationId: string;
};

export type GetPlanUsageError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.PlanUsageResponse;
}>;

export type GetPlanUsageVariables = {
  pathParams: GetPlanUsagePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetPlanUsage = (
  variables: GetPlanUsageVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetPlanUsageError,
    undefined,
    {},
    {},
    GetPlanUsagePathParams
  >({
    url: '/user-account/organization/{organizationId}/plan-usage',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetPlanUsage = <TData = undefined>(
  variables: GetPlanUsageVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetPlanUsageError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetPlanUsageError, TData>(
    queryKeyFn({
      path: '/user-account/organization/{organizationId}/plan-usage',
      operationId: 'getPlanUsage',
      variables,
    }),
    ({ signal }) =>
      fetchGetPlanUsage({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetPlansError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.PlanResponse[];
}>;

export type GetPlansVariables = OpenapiContext['fetcherOptions'];

export const fetchGetPlans = (
  variables: GetPlansVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, GetPlansError, undefined, {}, {}, {}>({
    url: '/plans',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetPlans = <TData = undefined>(
  variables: GetPlansVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetPlansError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetPlansError, TData>(
    queryKeyFn({ path: '/plans', operationId: 'getPlans', variables }),
    ({ signal }) => fetchGetPlans({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type HandleSubscriptionPathParams = {
  planType: string;
  interval: string;
  organizationId: string;
};

export type HandleSubscriptionError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.SubscribeResponse;
}>;

export type HandleSubscriptionVariables = {
  pathParams: HandleSubscriptionPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchHandleSubscription = (
  variables: HandleSubscriptionVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    HandleSubscriptionError,
    undefined,
    {},
    {},
    HandleSubscriptionPathParams
  >({
    url: '/plans/{planType}/interval/{interval}/organization/{organizationId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useHandleSubscription = <TData = undefined>(
  variables: HandleSubscriptionVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, HandleSubscriptionError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, HandleSubscriptionError, TData>(
    queryKeyFn({
      path: '/plans/{planType}/interval/{interval}/organization/{organizationId}',
      operationId: 'handleSubscription',
      variables,
    }),
    ({ signal }) =>
      fetchHandleSubscription({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetSubscriptionPriceChangePreviewPathParams = {
  planType: string;
  interval: string;
  organizationId: string;
};

export type GetSubscriptionPriceChangePreviewError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.SubscriptionChangePreviewResponse;
}>;

export type GetSubscriptionPriceChangePreviewVariables = {
  pathParams: GetSubscriptionPriceChangePreviewPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetSubscriptionPriceChangePreview = (
  variables: GetSubscriptionPriceChangePreviewVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetSubscriptionPriceChangePreviewError,
    undefined,
    {},
    {},
    GetSubscriptionPriceChangePreviewPathParams
  >({
    url: '/plans/{planType}/interval/{interval}/organization/{organizationId}/preview',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetSubscriptionPriceChangePreview = <TData = undefined>(
  variables: GetSubscriptionPriceChangePreviewVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetSubscriptionPriceChangePreviewError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    undefined,
    GetSubscriptionPriceChangePreviewError,
    TData
  >(
    queryKeyFn({
      path: '/plans/{planType}/interval/{interval}/organization/{organizationId}/preview',
      operationId: 'getSubscriptionPriceChangePreview',
      variables,
    }),
    ({ signal }) =>
      fetchGetSubscriptionPriceChangePreview(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UpdateOrganizationPathParams = {
  id: string;
};

export type UpdateOrganizationError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.OrganizationResponse;
}>;

export type UpdateOrganizationVariables = {
  body?: Schemas.EditOrganizationRequest;
  pathParams: UpdateOrganizationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateOrganization = (
  variables: UpdateOrganizationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateOrganizationError,
    Schemas.EditOrganizationRequest,
    {},
    {},
    UpdateOrganizationPathParams
  >({ url: '/organizations/{id}', method: 'patch', ...variables, signal });

export const useUpdateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateOrganizationError,
      UpdateOrganizationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateOrganizationError,
    UpdateOrganizationVariables
  >(
    (variables: UpdateOrganizationVariables) =>
      fetchUpdateOrganization({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetOrganizationMembershipsPathParams = {
  id: string;
};

export type GetOrganizationMembershipsError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.OrganizationMembershipResponse;
}>;

export type GetOrganizationMembershipsVariables = {
  pathParams: GetOrganizationMembershipsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrganizationMemberships = (
  variables: GetOrganizationMembershipsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetOrganizationMembershipsError,
    undefined,
    {},
    {},
    GetOrganizationMembershipsPathParams
  >({ url: '/organizations/{id}', method: 'get', ...variables, signal });

export const useGetOrganizationMemberships = <TData = undefined>(
  variables: GetOrganizationMembershipsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetOrganizationMembershipsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetOrganizationMembershipsError, TData>(
    queryKeyFn({
      path: '/organizations/{id}',
      operationId: 'getOrganizationMemberships',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrganizationMemberships(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type CreateShareKeyPathParams = {
  id: string;
};

export type CreateShareKeyError = Fetcher.ErrorWrapper<undefined>;

export type CreateShareKeyVariables = {
  pathParams: CreateShareKeyPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchCreateShareKey = (
  variables: CreateShareKeyVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    CreateShareKeyError,
    undefined,
    {},
    {},
    CreateShareKeyPathParams
  >({
    url: '/organizations/{id}/share-key',
    method: 'patch',
    ...variables,
    signal,
  });

export const useCreateShareKey = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      CreateShareKeyError,
      CreateShareKeyVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    CreateShareKeyError,
    CreateShareKeyVariables
  >(
    (variables: CreateShareKeyVariables) =>
      fetchCreateShareKey({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RemoveShareKeyPathParams = {
  id: string;
};

export type RemoveShareKeyError = Fetcher.ErrorWrapper<undefined>;

export type RemoveShareKeyVariables = {
  pathParams: RemoveShareKeyPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRemoveShareKey = (
  variables: RemoveShareKeyVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RemoveShareKeyError,
    undefined,
    {},
    {},
    RemoveShareKeyPathParams
  >({
    url: '/organizations/{id}/share-key/remove',
    method: 'patch',
    ...variables,
    signal,
  });

export const useRemoveShareKey = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveShareKeyError,
      RemoveShareKeyVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveShareKeyError,
    RemoveShareKeyVariables
  >(
    (variables: RemoveShareKeyVariables) =>
      fetchRemoveShareKey({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type InviteOrganizationMemberPathParams = {
  id: string;
};

export type InviteOrganizationMemberError = Fetcher.ErrorWrapper<undefined>;

export type InviteOrganizationMemberVariables = {
  body: Schemas.InviteOrganizationMemberRequest;
  pathParams: InviteOrganizationMemberPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchInviteOrganizationMember = (
  variables: InviteOrganizationMemberVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    InviteOrganizationMemberError,
    Schemas.InviteOrganizationMemberRequest,
    {},
    {},
    InviteOrganizationMemberPathParams
  >({
    url: '/organizations/{id}/invite',
    method: 'post',
    ...variables,
    signal,
  });

export const useInviteOrganizationMember = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      InviteOrganizationMemberError,
      InviteOrganizationMemberVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    InviteOrganizationMemberError,
    InviteOrganizationMemberVariables
  >(
    (variables: InviteOrganizationMemberVariables) =>
      fetchInviteOrganizationMember({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetOrganizationInvitationsPathParams = {
  id: string;
};

export type GetOrganizationInvitationsQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
};

export type GetOrganizationInvitationsError = Fetcher.ErrorWrapper<undefined>;

export type GetOrganizationInvitationsResponse = {
  data: Schemas.OrganizationInvitationResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetOrganizationInvitationsVariables = {
  pathParams: GetOrganizationInvitationsPathParams;
  queryParams?: GetOrganizationInvitationsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrganizationInvitations = (
  variables: GetOrganizationInvitationsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetOrganizationInvitationsResponse,
    GetOrganizationInvitationsError,
    undefined,
    {},
    GetOrganizationInvitationsQueryParams,
    GetOrganizationInvitationsPathParams
  >({ url: '/organizations/{id}/invite', method: 'get', ...variables, signal });

export const useGetOrganizationInvitations = <
  TData = GetOrganizationInvitationsResponse,
>(
  variables: GetOrganizationInvitationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetOrganizationInvitationsResponse,
      GetOrganizationInvitationsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetOrganizationInvitationsResponse,
    GetOrganizationInvitationsError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/invite',
      operationId: 'getOrganizationInvitations',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrganizationInvitations(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetOrgInvitationByTokenIdQueryParams = {
  token: string;
};

export type GetOrgInvitationByTokenIdError = Fetcher.ErrorWrapper<undefined>;

export type GetOrgInvitationByTokenIdVariables = {
  queryParams: GetOrgInvitationByTokenIdQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrgInvitationByTokenId = (
  variables: GetOrgInvitationByTokenIdVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetOrgInvitationByTokenIdError,
    undefined,
    {},
    GetOrgInvitationByTokenIdQueryParams,
    {}
  >({
    url: '/organizations/invitation/details',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetOrgInvitationByTokenId = <TData = undefined>(
  variables: GetOrgInvitationByTokenIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetOrgInvitationByTokenIdError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetOrgInvitationByTokenIdError, TData>(
    queryKeyFn({
      path: '/organizations/invitation/details',
      operationId: 'getOrgInvitationByTokenId',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrgInvitationByTokenId(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type RemoveOrgInvitationPathParams = {
  id: string;
  invitationId: string;
};

export type RemoveOrgInvitationError = Fetcher.ErrorWrapper<undefined>;

export type RemoveOrgInvitationVariables = {
  pathParams: RemoveOrgInvitationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRemoveOrgInvitation = (
  variables: RemoveOrgInvitationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RemoveOrgInvitationError,
    undefined,
    {},
    {},
    RemoveOrgInvitationPathParams
  >({
    url: '/organizations/{id}/invite/{invitationId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useRemoveOrgInvitation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveOrgInvitationError,
      RemoveOrgInvitationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveOrgInvitationError,
    RemoveOrgInvitationVariables
  >(
    (variables: RemoveOrgInvitationVariables) =>
      fetchRemoveOrgInvitation({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RemoveUserAccountFromOrganizationPathParams = {
  id: string;
  memberId: string;
};

export type RemoveUserAccountFromOrganizationError =
  Fetcher.ErrorWrapper<undefined>;

export type RemoveUserAccountFromOrganizationVariables = {
  pathParams: RemoveUserAccountFromOrganizationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRemoveUserAccountFromOrganization = (
  variables: RemoveUserAccountFromOrganizationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RemoveUserAccountFromOrganizationError,
    undefined,
    {},
    {},
    RemoveUserAccountFromOrganizationPathParams
  >({
    url: '/organizations/{id}/members/{memberId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useRemoveUserAccountFromOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveUserAccountFromOrganizationError,
      RemoveUserAccountFromOrganizationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveUserAccountFromOrganizationError,
    RemoveUserAccountFromOrganizationVariables
  >(
    (variables: RemoveUserAccountFromOrganizationVariables) =>
      fetchRemoveUserAccountFromOrganization({
        ...fetcherOptions,
        ...variables,
      }),
    options,
  );
};

export type UpdateInvitationStatusPathParams = {
  invitationId: string;
  organizationId: string;
};

export type UpdateInvitationStatusError = Fetcher.ErrorWrapper<undefined>;

export type UpdateInvitationStatusVariables = {
  body: Schemas.UpdateOrganizationInvitationRequest;
  pathParams: UpdateInvitationStatusPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateInvitationStatus = (
  variables: UpdateInvitationStatusVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateInvitationStatusError,
    Schemas.UpdateOrganizationInvitationRequest,
    {},
    {},
    UpdateInvitationStatusPathParams
  >({
    url: '/organizations/{organizationId}/invite/{invitationId}',
    method: 'put',
    ...variables,
    signal,
  });

export const useUpdateInvitationStatus = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateInvitationStatusError,
      UpdateInvitationStatusVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateInvitationStatusError,
    UpdateInvitationStatusVariables
  >(
    (variables: UpdateInvitationStatusVariables) =>
      fetchUpdateInvitationStatus({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetAiAssistantPathParams = {
  id: string;
};

export type GetAiAssistantError = Fetcher.ErrorWrapper<undefined>;

export type GetAiAssistantVariables = {
  pathParams: GetAiAssistantPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetAiAssistant = (
  variables: GetAiAssistantVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.AiAssistantResponseDto,
    GetAiAssistantError,
    undefined,
    {},
    {},
    GetAiAssistantPathParams
  >({
    url: '/organizations/{id}/ai-assistant',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetAiAssistant = <TData = Schemas.AiAssistantResponseDto>(
  variables: GetAiAssistantVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.AiAssistantResponseDto,
      GetAiAssistantError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.AiAssistantResponseDto,
    GetAiAssistantError,
    TData
  >(
    queryKeyFn({
      path: '/organizations/{id}/ai-assistant',
      operationId: 'getAiAssistant',
      variables,
    }),
    ({ signal }) =>
      fetchGetAiAssistant({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetAiAssistantFilesPathParams = {
  id: string;
};

export type GetAiAssistantFilesError = Fetcher.ErrorWrapper<undefined>;

export type GetAiAssistantFilesVariables = {
  pathParams: GetAiAssistantFilesPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetAiAssistantFiles = (
  variables: GetAiAssistantFilesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetAiAssistantFilesError,
    undefined,
    {},
    {},
    GetAiAssistantFilesPathParams
  >({
    url: '/organizations/{id}/ai-assistant/files',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetAiAssistantFiles = <TData = undefined>(
  variables: GetAiAssistantFilesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetAiAssistantFilesError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetAiAssistantFilesError, TData>(
    queryKeyFn({
      path: '/organizations/{id}/ai-assistant/files',
      operationId: 'getAiAssistantFiles',
      variables,
    }),
    ({ signal }) =>
      fetchGetAiAssistantFiles({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UploadFileForAiAssistantPathParams = {
  id: string;
};

export type UploadFileForAiAssistantError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.FileUploadResponse;
}>;

export type UploadFileForAiAssistantVariables = {
  pathParams: UploadFileForAiAssistantPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUploadFileForAiAssistant = (
  variables: UploadFileForAiAssistantVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UploadFileForAiAssistantError,
    undefined,
    {},
    {},
    UploadFileForAiAssistantPathParams
  >({
    url: '/organizations/{id}/ai-assistant/files',
    method: 'post',
    ...variables,
    signal,
  });

export const useUploadFileForAiAssistant = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UploadFileForAiAssistantError,
      UploadFileForAiAssistantVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UploadFileForAiAssistantError,
    UploadFileForAiAssistantVariables
  >(
    (variables: UploadFileForAiAssistantVariables) =>
      fetchUploadFileForAiAssistant({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteFileForAiAssistantPathParams = {
  id: string;
  fileId: string;
};

export type DeleteFileForAiAssistantError = Fetcher.ErrorWrapper<undefined>;

export type DeleteFileForAiAssistantVariables = {
  pathParams: DeleteFileForAiAssistantPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteFileForAiAssistant = (
  variables: DeleteFileForAiAssistantVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteFileForAiAssistantError,
    undefined,
    {},
    {},
    DeleteFileForAiAssistantPathParams
  >({
    url: '/organizations/{id}/ai-assistant/files/{fileId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteFileForAiAssistant = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteFileForAiAssistantError,
      DeleteFileForAiAssistantVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteFileForAiAssistantError,
    DeleteFileForAiAssistantVariables
  >(
    (variables: DeleteFileForAiAssistantVariables) =>
      fetchDeleteFileForAiAssistant({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetOrganizationsSharedProcsQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  shareCode: string;
  /**
   * Search term to filter procs by title
   */
  searchTerm?: string;
};

export type GetOrganizationsSharedProcsError = Fetcher.ErrorWrapper<undefined>;

export type GetOrganizationsSharedProcsResponse = {
  data: Schemas.ProcSearchResponse[];
  meta: Schemas.PageMetaResponse;
};

export type GetOrganizationsSharedProcsVariables = {
  queryParams: GetOrganizationsSharedProcsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrganizationsSharedProcs = (
  variables: GetOrganizationsSharedProcsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetOrganizationsSharedProcsResponse,
    GetOrganizationsSharedProcsError,
    undefined,
    {},
    GetOrganizationsSharedProcsQueryParams,
    {}
  >({
    url: '/public/organizations/procs',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetOrganizationsSharedProcs = <
  TData = GetOrganizationsSharedProcsResponse,
>(
  variables: GetOrganizationsSharedProcsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetOrganizationsSharedProcsResponse,
      GetOrganizationsSharedProcsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetOrganizationsSharedProcsResponse,
    GetOrganizationsSharedProcsError,
    TData
  >(
    queryKeyFn({
      path: '/public/organizations/procs',
      operationId: 'getOrganizationsSharedProcs',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrganizationsSharedProcs(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetOrganizationByShareCodePathParams = {
  shareCode: string;
};

export type GetOrganizationByShareCodeError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.OrganizationShareResponse;
}>;

export type GetOrganizationByShareCodeVariables = {
  pathParams: GetOrganizationByShareCodePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrganizationByShareCode = (
  variables: GetOrganizationByShareCodeVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetOrganizationByShareCodeError,
    undefined,
    {},
    {},
    GetOrganizationByShareCodePathParams
  >({
    url: '/public/organizations/{shareCode}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetOrganizationByShareCode = <TData = undefined>(
  variables: GetOrganizationByShareCodeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetOrganizationByShareCodeError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetOrganizationByShareCodeError, TData>(
    queryKeyFn({
      path: '/public/organizations/{shareCode}',
      operationId: 'getOrganizationByShareCode',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrganizationByShareCode(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type StartOrgAiConversationPathParams = {
  orgId: string;
};

export type StartOrgAiConversationError = Fetcher.ErrorWrapper<undefined>;

export type StartOrgAiConversationVariables = {
  body: Schemas.StartOrgConversationRequest;
  pathParams: StartOrgAiConversationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchStartOrgAiConversation = (
  variables: StartOrgAiConversationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    StartOrgAiConversationError,
    Schemas.StartOrgConversationRequest,
    {},
    {},
    StartOrgAiConversationPathParams
  >({
    url: '/public/organizations/{orgId}/threads',
    method: 'post',
    ...variables,
    signal,
  });

export const useStartOrgAiConversation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      StartOrgAiConversationError,
      StartOrgAiConversationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    StartOrgAiConversationError,
    StartOrgAiConversationVariables
  >(
    (variables: StartOrgAiConversationVariables) =>
      fetchStartOrgAiConversation({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetOrgAiMessagesPathParams = {
  threadId: string;
};

export type GetOrgAiMessagesError = Fetcher.ErrorWrapper<undefined>;

export type GetOrgAiMessagesVariables = {
  pathParams: GetOrgAiMessagesPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrgAiMessages = (
  variables: GetOrgAiMessagesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetOrgAiMessagesError,
    undefined,
    {},
    {},
    GetOrgAiMessagesPathParams
  >({
    url: '/public/organizations/threads/{threadId}/messages',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetOrgAiMessages = <TData = undefined>(
  variables: GetOrgAiMessagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, GetOrgAiMessagesError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, GetOrgAiMessagesError, TData>(
    queryKeyFn({
      path: '/public/organizations/threads/{threadId}/messages',
      operationId: 'getOrgAiMessages',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrgAiMessages({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type SendOrgAiMessagePathParams = {
  orgId: string;
  threadId: string;
};

export type SendOrgAiMessageError = Fetcher.ErrorWrapper<undefined>;

export type SendOrgAiMessageVariables = {
  body: Schemas.SendOrgAiMessageRequest;
  pathParams: SendOrgAiMessagePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchSendOrgAiMessage = (
  variables: SendOrgAiMessageVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    SendOrgAiMessageError,
    Schemas.SendOrgAiMessageRequest,
    {},
    {},
    SendOrgAiMessagePathParams
  >({
    url: '/public/organizations/{orgId}/threads/{threadId}/messages',
    method: 'post',
    ...variables,
    signal,
  });

export const useSendOrgAiMessage = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SendOrgAiMessageError,
      SendOrgAiMessageVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    SendOrgAiMessageError,
    SendOrgAiMessageVariables
  >(
    (variables: SendOrgAiMessageVariables) =>
      fetchSendOrgAiMessage({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type UploadFileToOrganizationPathParams = {
  organizationId: string;
};

export type UploadFileToOrganizationError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.FileUploadResponse;
}>;

export type UploadFileToOrganizationVariables = {
  body: Schemas.OrgImageUploadRequest;
  pathParams: UploadFileToOrganizationPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUploadFileToOrganization = (
  variables: UploadFileToOrganizationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.FileUploadResponse,
    UploadFileToOrganizationError,
    Schemas.OrgImageUploadRequest,
    {},
    {},
    UploadFileToOrganizationPathParams
  >({
    url: '/organizations/{organizationId}/file-upload',
    method: 'post',
    ...variables,
    signal,
  });

export const useUploadFileToOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FileUploadResponse,
      UploadFileToOrganizationError,
      UploadFileToOrganizationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.FileUploadResponse,
    UploadFileToOrganizationError,
    UploadFileToOrganizationVariables
  >(
    (variables: UploadFileToOrganizationVariables) =>
      fetchUploadFileToOrganization({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetMyAccountError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.UserAccountResponse;
}>;

export type GetMyAccountVariables = OpenapiContext['fetcherOptions'];

export const fetchGetMyAccount = (
  variables: GetMyAccountVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.UserAccountResponse,
    GetMyAccountError,
    undefined,
    {},
    {},
    {}
  >({ url: '/accounts/my-profile', method: 'get', ...variables, signal });

export const useGetMyAccount = <TData = Schemas.UserAccountResponse>(
  variables: GetMyAccountVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.UserAccountResponse,
      GetMyAccountError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.UserAccountResponse,
    GetMyAccountError,
    TData
  >(
    queryKeyFn({
      path: '/accounts/my-profile',
      operationId: 'getMyAccount',
      variables,
    }),
    ({ signal }) =>
      fetchGetMyAccount({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UpdateMyAccountError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.UserAccountResponse;
}>;

export type UpdateMyAccountVariables = {
  body?: Schemas.UpdateMyAccountRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateMyAccount = (
  variables: UpdateMyAccountVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UpdateMyAccountError,
    Schemas.UpdateMyAccountRequest,
    {},
    {},
    {}
  >({ url: '/accounts/my-profile', method: 'patch', ...variables, signal });

export const useUpdateMyAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UpdateMyAccountError,
      UpdateMyAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UpdateMyAccountError,
    UpdateMyAccountVariables
  >(
    (variables: UpdateMyAccountVariables) =>
      fetchUpdateMyAccount({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteMyAccountError = Fetcher.ErrorWrapper<undefined>;

export type DeleteMyAccountVariables = OpenapiContext['fetcherOptions'];

export const fetchDeleteMyAccount = (
  variables: DeleteMyAccountVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, DeleteMyAccountError, undefined, {}, {}, {}>({
    url: '/accounts/my-profile',
    method: 'delete',
    ...variables,
    signal,
  });

export const useDeleteMyAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteMyAccountError,
      DeleteMyAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteMyAccountError,
    DeleteMyAccountVariables
  >(
    (variables: DeleteMyAccountVariables) =>
      fetchDeleteMyAccount({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RegisterAccountError = Fetcher.ErrorWrapper<undefined>;

export type RegisterAccountVariables = {
  body: Schemas.AccountRegisterRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchRegisterAccount = (
  variables: RegisterAccountVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RegisterAccountError,
    Schemas.AccountRegisterRequest,
    {},
    {},
    {}
  >({ url: '/users/register', method: 'post', ...variables, signal });

export const useRegisterAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RegisterAccountError,
      RegisterAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RegisterAccountError,
    RegisterAccountVariables
  >(
    (variables: RegisterAccountVariables) =>
      fetchRegisterAccount({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ResendActivationEmailForAccountError =
  Fetcher.ErrorWrapper<undefined>;

export type ResendActivationEmailForAccountVariables = {
  body: Schemas.ActivationEmailRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchResendActivationEmailForAccount = (
  variables: ResendActivationEmailForAccountVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    ResendActivationEmailForAccountError,
    Schemas.ActivationEmailRequest,
    {},
    {},
    {}
  >({ url: '/users/verification-email', method: 'post', ...variables, signal });

export const useResendActivationEmailForAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ResendActivationEmailForAccountError,
      ResendActivationEmailForAccountVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    ResendActivationEmailForAccountError,
    ResendActivationEmailForAccountVariables
  >(
    (variables: ResendActivationEmailForAccountVariables) =>
      fetchResendActivationEmailForAccount({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type StartProcCreationError = Fetcher.ErrorWrapper<undefined>;

export type StartProcCreationVariables = {
  body: Schemas.AiAssistantProcCreationRequest;
} & OpenapiContext['fetcherOptions'];

export const fetchStartProcCreation = (
  variables: StartProcCreationVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ProcCreationInitiatedResponse,
    StartProcCreationError,
    Schemas.AiAssistantProcCreationRequest,
    {},
    {},
    {}
  >({
    url: '/ai-assistant-proc-creation/create',
    method: 'post',
    ...variables,
    signal,
  });

export const useStartProcCreation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ProcCreationInitiatedResponse,
      StartProcCreationError,
      StartProcCreationVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.ProcCreationInitiatedResponse,
    StartProcCreationError,
    StartProcCreationVariables
  >(
    (variables: StartProcCreationVariables) =>
      fetchStartProcCreation({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RegenerateProcPathParams = {
  procId: string;
};

export type RegenerateProcError = Fetcher.ErrorWrapper<undefined>;

export type RegenerateProcVariables = {
  body: Schemas.RegenerateProcRequest;
  pathParams: RegenerateProcPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRegenerateProc = (
  variables: RegenerateProcVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ProcDetailsResponse,
    RegenerateProcError,
    Schemas.RegenerateProcRequest,
    {},
    {},
    RegenerateProcPathParams
  >({
    url: '/ai-assistant-proc-creation/regenerate/{procId}',
    method: 'post',
    ...variables,
    signal,
  });

export const useRegenerateProc = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ProcDetailsResponse,
      RegenerateProcError,
      RegenerateProcVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.ProcDetailsResponse,
    RegenerateProcError,
    RegenerateProcVariables
  >(
    (variables: RegenerateProcVariables) =>
      fetchRegenerateProc({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetMediaAssetsQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  /**
   * The list of file IDs
   */
  fileId: string[];
};

export type GetMediaAssetsError = Fetcher.ErrorWrapper<undefined>;

export type GetMediaAssetsResponse = {
  data: Schemas.MediaAssetResponseDto[];
  meta: Schemas.PageMetaResponse;
};

export type GetMediaAssetsVariables = {
  queryParams: GetMediaAssetsQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetMediaAssets = (
  variables: GetMediaAssetsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetMediaAssetsResponse,
    GetMediaAssetsError,
    undefined,
    {},
    GetMediaAssetsQueryParams,
    {}
  >({ url: '/media-assets/files', method: 'get', ...variables, signal });

export const useGetMediaAssets = <TData = GetMediaAssetsResponse>(
  variables: GetMediaAssetsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetMediaAssetsResponse,
      GetMediaAssetsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetMediaAssetsResponse,
    GetMediaAssetsError,
    TData
  >(
    queryKeyFn({
      path: '/media-assets/files',
      operationId: 'getMediaAssets',
      variables,
    }),
    ({ signal }) =>
      fetchGetMediaAssets({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetOrganizationFilesPathParams = {
  organizationId: string;
};

export type GetOrganizationFilesQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  searchTerm?: string;
  labelIds?: string[];
};

export type GetOrganizationFilesError = Fetcher.ErrorWrapper<undefined>;

export type GetOrganizationFilesResponse = {
  data: Schemas.FileResponseDto[];
  meta: Schemas.PageMetaResponse;
};

export type GetOrganizationFilesVariables = {
  pathParams: GetOrganizationFilesPathParams;
  queryParams?: GetOrganizationFilesQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * Get all files for organization with pagination support
 */
export const fetchGetOrganizationFiles = (
  variables: GetOrganizationFilesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetOrganizationFilesResponse,
    GetOrganizationFilesError,
    undefined,
    {},
    GetOrganizationFilesQueryParams,
    GetOrganizationFilesPathParams
  >({
    url: '/files/organization/{organizationId}',
    method: 'get',
    ...variables,
    signal,
  });

/**
 * Get all files for organization with pagination support
 */
export const useGetOrganizationFiles = <TData = GetOrganizationFilesResponse>(
  variables: GetOrganizationFilesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetOrganizationFilesResponse,
      GetOrganizationFilesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetOrganizationFilesResponse,
    GetOrganizationFilesError,
    TData
  >(
    queryKeyFn({
      path: '/files/organization/{organizationId}',
      operationId: 'getOrganizationFiles',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrganizationFiles({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UploadOrganizationFileError = Fetcher.ErrorWrapper<{
  status: ClientErrorStatus | ServerErrorStatus;
  payload: Schemas.FileModel;
}>;

export type UploadOrganizationFileVariables = {
  body: Schemas.FileUploadBodyDto;
} & OpenapiContext['fetcherOptions'];

export const fetchUploadOrganizationFile = (
  variables: UploadOrganizationFileVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UploadOrganizationFileError,
    Schemas.FileUploadBodyDto,
    {},
    {},
    {}
  >({ url: '/files/upload', method: 'post', ...variables, signal });

export const useUploadOrganizationFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UploadOrganizationFileError,
      UploadOrganizationFileVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UploadOrganizationFileError,
    UploadOrganizationFileVariables
  >(
    (variables: UploadOrganizationFileVariables) =>
      fetchUploadOrganizationFile({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteFilePathParams = {
  fileId: string;
};

export type DeleteFileError = Fetcher.ErrorWrapper<undefined>;

export type DeleteFileVariables = {
  pathParams: DeleteFilePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteFile = (
  variables: DeleteFileVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteFileError,
    undefined,
    {},
    {},
    DeleteFilePathParams
  >({ url: '/files/{fileId}', method: 'delete', ...variables, signal });

export const useDeleteFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteFileError,
      DeleteFileVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteFileError,
    DeleteFileVariables
  >(
    (variables: DeleteFileVariables) =>
      fetchDeleteFile({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetOrganizationLabelsPathParams = {
  organizationId: string;
};

export type GetOrganizationLabelsError = Fetcher.ErrorWrapper<undefined>;

export type GetOrganizationLabelsResponse = Schemas.FileLabelResponseDto[];

export type GetOrganizationLabelsVariables = {
  pathParams: GetOrganizationLabelsPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetOrganizationLabels = (
  variables: GetOrganizationLabelsVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    GetOrganizationLabelsResponse,
    GetOrganizationLabelsError,
    undefined,
    {},
    {},
    GetOrganizationLabelsPathParams
  >({
    url: '/file-labels/organization/{organizationId}',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetOrganizationLabels = <TData = GetOrganizationLabelsResponse>(
  variables: GetOrganizationLabelsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      GetOrganizationLabelsResponse,
      GetOrganizationLabelsError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    GetOrganizationLabelsResponse,
    GetOrganizationLabelsError,
    TData
  >(
    queryKeyFn({
      path: '/file-labels/organization/{organizationId}',
      operationId: 'getOrganizationLabels',
      variables,
    }),
    ({ signal }) =>
      fetchGetOrganizationLabels({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetLabelByIdPathParams = {
  id: string;
};

export type GetLabelByIdError = Fetcher.ErrorWrapper<undefined>;

export type GetLabelByIdVariables = {
  pathParams: GetLabelByIdPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetLabelById = (
  variables: GetLabelByIdVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.FileLabelDetailResponseDto,
    GetLabelByIdError,
    undefined,
    {},
    {},
    GetLabelByIdPathParams
  >({ url: '/file-labels/{id}', method: 'get', ...variables, signal });

export const useGetLabelById = <TData = Schemas.FileLabelDetailResponseDto>(
  variables: GetLabelByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.FileLabelDetailResponseDto,
      GetLabelByIdError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.FileLabelDetailResponseDto,
    GetLabelByIdError,
    TData
  >(
    queryKeyFn({
      path: '/file-labels/{id}',
      operationId: 'getLabelById',
      variables,
    }),
    ({ signal }) =>
      fetchGetLabelById({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UpdateLabelPathParams = {
  id: string;
};

export type UpdateLabelError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.FileLabelResponseDto;
}>;

export type UpdateLabelVariables = {
  body: Schemas.UpdateFileLabelRequestDto;
  pathParams: UpdateLabelPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUpdateLabel = (
  variables: UpdateLabelVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.FileLabelResponseDto,
    UpdateLabelError,
    Schemas.UpdateFileLabelRequestDto,
    {},
    {},
    UpdateLabelPathParams
  >({ url: '/file-labels/{id}', method: 'put', ...variables, signal });

export const useUpdateLabel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FileLabelResponseDto,
      UpdateLabelError,
      UpdateLabelVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.FileLabelResponseDto,
    UpdateLabelError,
    UpdateLabelVariables
  >(
    (variables: UpdateLabelVariables) =>
      fetchUpdateLabel({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type DeleteLabelPathParams = {
  id: string;
};

export type DeleteLabelError = Fetcher.ErrorWrapper<undefined>;

export type DeleteLabelVariables = {
  pathParams: DeleteLabelPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchDeleteLabel = (
  variables: DeleteLabelVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    DeleteLabelError,
    undefined,
    {},
    {},
    DeleteLabelPathParams
  >({ url: '/file-labels/{id}', method: 'delete', ...variables, signal });

export const useDeleteLabel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      DeleteLabelError,
      DeleteLabelVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    DeleteLabelError,
    DeleteLabelVariables
  >(
    (variables: DeleteLabelVariables) =>
      fetchDeleteLabel({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type CreateLabelError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 201>;
  payload: Schemas.FileLabelResponseDto;
}>;

export type CreateLabelVariables = {
  body: Schemas.CreateFileLabelRequestDto;
} & OpenapiContext['fetcherOptions'];

export const fetchCreateLabel = (
  variables: CreateLabelVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.FileLabelResponseDto,
    CreateLabelError,
    Schemas.CreateFileLabelRequestDto,
    {},
    {},
    {}
  >({ url: '/file-labels/create', method: 'post', ...variables, signal });

export const useCreateLabel = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.FileLabelResponseDto,
      CreateLabelError,
      CreateLabelVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.FileLabelResponseDto,
    CreateLabelError,
    CreateLabelVariables
  >(
    (variables: CreateLabelVariables) =>
      fetchCreateLabel({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type AssignLabelToFilePathParams = {
  labelId: string;
  fileId: string;
};

export type AssignLabelToFileError = Fetcher.ErrorWrapper<undefined>;

export type AssignLabelToFileVariables = {
  pathParams: AssignLabelToFilePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchAssignLabelToFile = (
  variables: AssignLabelToFileVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    AssignLabelToFileError,
    undefined,
    {},
    {},
    AssignLabelToFilePathParams
  >({
    url: '/file-labels/assign/{labelId}/file/{fileId}',
    method: 'post',
    ...variables,
    signal,
  });

export const useAssignLabelToFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AssignLabelToFileError,
      AssignLabelToFileVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    AssignLabelToFileError,
    AssignLabelToFileVariables
  >(
    (variables: AssignLabelToFileVariables) =>
      fetchAssignLabelToFile({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type RemoveLabelFromFilePathParams = {
  labelId: string;
  fileId: string;
};

export type RemoveLabelFromFileError = Fetcher.ErrorWrapper<undefined>;

export type RemoveLabelFromFileVariables = {
  pathParams: RemoveLabelFromFilePathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchRemoveLabelFromFile = (
  variables: RemoveLabelFromFileVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    RemoveLabelFromFileError,
    undefined,
    {},
    {},
    RemoveLabelFromFilePathParams
  >({
    url: '/file-labels/remove/{labelId}/file/{fileId}',
    method: 'delete',
    ...variables,
    signal,
  });

export const useRemoveLabelFromFile = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      RemoveLabelFromFileError,
      RemoveLabelFromFileVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    RemoveLabelFromFileError,
    RemoveLabelFromFileVariables
  >(
    (variables: RemoveLabelFromFileVariables) =>
      fetchRemoveLabelFromFile({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type CommentGetAllPathParams = {
  /**
   * @format uuid
   */
  instanceId: string;
  /**
   * @format uuid
   */
  stepId: string;
};

export type CommentGetAllQueryParams = {
  /**
   * @default ASC
   */
  order?: 'ASC' | 'DESC';
  /**
   * @minimum 1
   * @default 1
   */
  page?: number;
  /**
   * @minimum 1
   * @maximum 50
   * @default 10
   */
  take?: number;
  /**
   * Field to sort by
   */
  sortBy?: string;
  /**
   * @format uuid
   */
  code?: string;
};

export type CommentGetAllError = Fetcher.ErrorWrapper<{
  status: Exclude<ClientErrorStatus | ServerErrorStatus, 200>;
  payload: Schemas.CommentsResponse;
}>;

export type CommentGetAllResponse = {
  data: Schemas.CommentsResponse[];
  meta: Schemas.PageMetaResponse;
};

export type CommentGetAllVariables = {
  pathParams: CommentGetAllPathParams;
  queryParams?: CommentGetAllQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchCommentGetAll = (
  variables: CommentGetAllVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    CommentGetAllResponse,
    CommentGetAllError,
    undefined,
    {},
    CommentGetAllQueryParams,
    CommentGetAllPathParams
  >({
    url: '/instances/{instanceId}/step/{stepId}/comments',
    method: 'get',
    ...variables,
    signal,
  });

export const useCommentGetAll = <TData = CommentGetAllResponse>(
  variables: CommentGetAllVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      CommentGetAllResponse,
      CommentGetAllError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<CommentGetAllResponse, CommentGetAllError, TData>(
    queryKeyFn({
      path: '/instances/{instanceId}/step/{stepId}/comments',
      operationId: 'commentGetAll',
      variables,
    }),
    ({ signal }) =>
      fetchCommentGetAll({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type AddCommentPathParams = {
  /**
   * @format uuid
   */
  instanceId: string;
  /**
   * @format uuid
   */
  stepId: string;
};

export type AddCommentError = Fetcher.ErrorWrapper<undefined>;

export type AddCommentVariables = {
  body: Schemas.CommentAddRequestBody;
  pathParams: AddCommentPathParams;
} & OpenapiContext['fetcherOptions'];

export const fetchAddComment = (
  variables: AddCommentVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    AddCommentError,
    Schemas.CommentAddRequestBody,
    {},
    {},
    AddCommentPathParams
  >({
    url: '/instances/{instanceId}/step/{stepId}/comments',
    method: 'post',
    ...variables,
    signal,
  });

export const useAddComment = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      AddCommentError,
      AddCommentVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    AddCommentError,
    AddCommentVariables
  >(
    (variables: AddCommentVariables) =>
      fetchAddComment({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type TrackLoginError = Fetcher.ErrorWrapper<undefined>;

export type TrackLoginVariables = OpenapiContext['fetcherOptions'];

export const fetchTrackLogin = (
  variables: TrackLoginVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, TrackLoginError, undefined, {}, {}, {}>({
    url: '/welcome-back',
    method: 'get',
    ...variables,
    signal,
  });

export const useTrackLogin = <TData = undefined>(
  variables: TrackLoginVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, TrackLoginError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, TrackLoginError, TData>(
    queryKeyFn({ path: '/welcome-back', operationId: 'trackLogin', variables }),
    ({ signal }) =>
      fetchTrackLogin({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type SetSubscriptionEventError = Fetcher.ErrorWrapper<undefined>;

export type SetSubscriptionEventVariables = OpenapiContext['fetcherOptions'];

export const fetchSetSubscriptionEvent = (
  variables: SetSubscriptionEventVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, SetSubscriptionEventError, undefined, {}, {}, {}>({
    url: '/webhooks/event',
    method: 'post',
    ...variables,
    signal,
  });

export const useSetSubscriptionEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SetSubscriptionEventError,
      SetSubscriptionEventVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    SetSubscriptionEventError,
    SetSubscriptionEventVariables
  >(
    (variables: SetSubscriptionEventVariables) =>
      fetchSetSubscriptionEvent({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type InitiateConfluenceAuthError = Fetcher.ErrorWrapper<undefined>;

export type InitiateConfluenceAuthVariables = OpenapiContext['fetcherOptions'];

export const fetchInitiateConfluenceAuth = (
  variables: InitiateConfluenceAuthVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, InitiateConfluenceAuthError, undefined, {}, {}, {}>({
    url: '/confluence/initiate-oauth',
    method: 'get',
    ...variables,
    signal,
  });

export const useInitiateConfluenceAuth = <TData = undefined>(
  variables: InitiateConfluenceAuthVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, InitiateConfluenceAuthError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, InitiateConfluenceAuthError, TData>(
    queryKeyFn({
      path: '/confluence/initiate-oauth',
      operationId: 'initiateConfluenceAuth',
      variables,
    }),
    ({ signal }) =>
      fetchInitiateConfluenceAuth({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type HandleConfluenceCallbackQueryParams = {
  code: string;
  state: string;
};

export type HandleConfluenceCallbackError = Fetcher.ErrorWrapper<undefined>;

export type HandleConfluenceCallbackVariables = {
  queryParams: HandleConfluenceCallbackQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchHandleConfluenceCallback = (
  variables: HandleConfluenceCallbackVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    HandleConfluenceCallbackError,
    undefined,
    {},
    HandleConfluenceCallbackQueryParams,
    {}
  >({ url: '/confluence/oauth2callback', method: 'get', ...variables, signal });

export const useHandleConfluenceCallback = <TData = undefined>(
  variables: HandleConfluenceCallbackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, HandleConfluenceCallbackError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, HandleConfluenceCallbackError, TData>(
    queryKeyFn({
      path: '/confluence/oauth2callback',
      operationId: 'handleConfluenceCallback',
      variables,
    }),
    ({ signal }) =>
      fetchHandleConfluenceCallback(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type DeleteConfluenceConnectionError = Fetcher.ErrorWrapper<undefined>;

export type DeleteConfluenceConnectionVariables =
  OpenapiContext['fetcherOptions'];

/**
 * Delete the Confluence connection for the current organization
 */
export const fetchDeleteConfluenceConnection = (
  variables: DeleteConfluenceConnectionVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.DeleteConfluenceConnectionResponseDto,
    DeleteConfluenceConnectionError,
    undefined,
    {},
    {},
    {}
  >({ url: '/confluence/connection', method: 'delete', ...variables, signal });

/**
 * Delete the Confluence connection for the current organization
 */
export const useDeleteConfluenceConnection = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DeleteConfluenceConnectionResponseDto,
      DeleteConfluenceConnectionError,
      DeleteConfluenceConnectionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.DeleteConfluenceConnectionResponseDto,
    DeleteConfluenceConnectionError,
    DeleteConfluenceConnectionVariables
  >(
    (variables: DeleteConfluenceConnectionVariables) =>
      fetchDeleteConfluenceConnection({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type GetConfluenceConnectionStatusError =
  Fetcher.ErrorWrapper<undefined>;

export type GetConfluenceConnectionStatusVariables =
  OpenapiContext['fetcherOptions'];

export const fetchGetConfluenceConnectionStatus = (
  variables: GetConfluenceConnectionStatusVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetConfluenceConnectionStatusError,
    undefined,
    {},
    {},
    {}
  >({
    url: '/confluence/connection-status',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetConfluenceConnectionStatus = <TData = undefined>(
  variables: GetConfluenceConnectionStatusVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetConfluenceConnectionStatusError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    undefined,
    GetConfluenceConnectionStatusError,
    TData
  >(
    queryKeyFn({
      path: '/confluence/connection-status',
      operationId: 'getConfluenceConnectionStatus',
      variables,
    }),
    ({ signal }) =>
      fetchGetConfluenceConnectionStatus(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ListConfluenceSitesError = Fetcher.ErrorWrapper<undefined>;

export type ListConfluenceSitesVariables = OpenapiContext['fetcherOptions'];

/**
 * List all available confluence sites.
 */
export const fetchListConfluenceSites = (
  variables: ListConfluenceSitesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ListConfluenceSitesResponseDto,
    ListConfluenceSitesError,
    undefined,
    {},
    {},
    {}
  >({ url: '/confluence/sites', method: 'get', ...variables, signal });

/**
 * List all available confluence sites.
 */
export const useListConfluenceSites = <
  TData = Schemas.ListConfluenceSitesResponseDto,
>(
  variables: ListConfluenceSitesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListConfluenceSitesResponseDto,
      ListConfluenceSitesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.ListConfluenceSitesResponseDto,
    ListConfluenceSitesError,
    TData
  >(
    queryKeyFn({
      path: '/confluence/sites',
      operationId: 'listConfluenceSites',
      variables,
    }),
    ({ signal }) =>
      fetchListConfluenceSites({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ListConfluenceSiteSpacesQueryParams = {
  /**
   * The ID of the site
   */
  siteId: string;
  /**
   * The type of the displayed spaces
   */
  spaceType: 'global' | 'collaboration' | 'knowledge_base' | 'personal';
};

export type ListConfluenceSiteSpacesError = Fetcher.ErrorWrapper<undefined>;

export type ListConfluenceSiteSpacesVariables = {
  queryParams: ListConfluenceSiteSpacesQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * List all available confluence site spaces.
 */
export const fetchListConfluenceSiteSpaces = (
  variables: ListConfluenceSiteSpacesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ListConfluenceSpacesResponseDto,
    ListConfluenceSiteSpacesError,
    undefined,
    {},
    ListConfluenceSiteSpacesQueryParams,
    {}
  >({ url: '/confluence/spaces', method: 'get', ...variables, signal });

/**
 * List all available confluence site spaces.
 */
export const useListConfluenceSiteSpaces = <
  TData = Schemas.ListConfluenceSpacesResponseDto,
>(
  variables: ListConfluenceSiteSpacesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListConfluenceSpacesResponseDto,
      ListConfluenceSiteSpacesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.ListConfluenceSpacesResponseDto,
    ListConfluenceSiteSpacesError,
    TData
  >(
    queryKeyFn({
      path: '/confluence/spaces',
      operationId: 'listConfluenceSiteSpaces',
      variables,
    }),
    ({ signal }) =>
      fetchListConfluenceSiteSpaces(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ListConfluenceSpacePagesQueryParams = {
  /**
   * The ID of the site
   */
  siteId: string;
  /**
   * The ID of the space
   */
  spaceId: string;
};

export type ListConfluenceSpacePagesError = Fetcher.ErrorWrapper<undefined>;

export type ListConfluenceSpacePagesVariables = {
  queryParams: ListConfluenceSpacePagesQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * List all available confluence pages for a registered domain.
 */
export const fetchListConfluenceSpacePages = (
  variables: ListConfluenceSpacePagesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ListConfluencePagesResponseDto,
    ListConfluenceSpacePagesError,
    undefined,
    {},
    ListConfluenceSpacePagesQueryParams,
    {}
  >({ url: '/confluence/pages', method: 'get', ...variables, signal });

/**
 * List all available confluence pages for a registered domain.
 */
export const useListConfluenceSpacePages = <
  TData = Schemas.ListConfluencePagesResponseDto,
>(
  variables: ListConfluenceSpacePagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListConfluencePagesResponseDto,
      ListConfluenceSpacePagesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.ListConfluencePagesResponseDto,
    ListConfluenceSpacePagesError,
    TData
  >(
    queryKeyFn({
      path: '/confluence/pages',
      operationId: 'listConfluenceSpacePages',
      variables,
    }),
    ({ signal }) =>
      fetchListConfluenceSpacePages(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ListConfluencePageContentQueryParams = {
  /**
   * The ID of the site
   */
  siteId: string;
  /**
   * The ID of the page
   */
  pageId: string;
};

export type ListConfluencePageContentError = Fetcher.ErrorWrapper<undefined>;

export type ListConfluencePageContentVariables = {
  queryParams: ListConfluencePageContentQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * List all available confluence files and subpages for a registered domain.
 */
export const fetchListConfluencePageContent = (
  variables: ListConfluencePageContentVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ListConfluenceContentResponseDto,
    ListConfluencePageContentError,
    undefined,
    {},
    ListConfluencePageContentQueryParams,
    {}
  >({ url: '/confluence/content', method: 'get', ...variables, signal });

/**
 * List all available confluence files and subpages for a registered domain.
 */
export const useListConfluencePageContent = <
  TData = Schemas.ListConfluenceContentResponseDto,
>(
  variables: ListConfluencePageContentVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListConfluenceContentResponseDto,
      ListConfluencePageContentError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.ListConfluenceContentResponseDto,
    ListConfluencePageContentError,
    TData
  >(
    queryKeyFn({
      path: '/confluence/content',
      operationId: 'listConfluencePageContent',
      variables,
    }),
    ({ signal }) =>
      fetchListConfluencePageContent(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UploadConfluenceFilesToOpenAIQueryParams = {
  /**
   * The ID of the site
   */
  siteId: string;
  /**
   * The ID of the page
   */
  pageId: string;
};

export type UploadConfluenceFilesToOpenAIError =
  Fetcher.ErrorWrapper<undefined>;

export type UploadConfluenceFilesToOpenAIVariables = {
  body: Schemas.UploadConfluenceFilesReqBodyDto;
  queryParams: UploadConfluenceFilesToOpenAIQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchUploadConfluenceFilesToOpenAI = (
  variables: UploadConfluenceFilesToOpenAIVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UploadConfluenceFilesToOpenAIError,
    Schemas.UploadConfluenceFilesReqBodyDto,
    {},
    UploadConfluenceFilesToOpenAIQueryParams,
    {}
  >({ url: '/confluence/upload-files', method: 'post', ...variables, signal });

export const useUploadConfluenceFilesToOpenAI = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UploadConfluenceFilesToOpenAIError,
      UploadConfluenceFilesToOpenAIVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UploadConfluenceFilesToOpenAIError,
    UploadConfluenceFilesToOpenAIVariables
  >(
    (variables: UploadConfluenceFilesToOpenAIVariables) =>
      fetchUploadConfluenceFilesToOpenAI({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type InitiateGoogleDriveAuthError = Fetcher.ErrorWrapper<undefined>;

export type InitiateGoogleDriveAuthVariables = OpenapiContext['fetcherOptions'];

export const fetchInitiateGoogleDriveAuth = (
  variables: InitiateGoogleDriveAuthVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, InitiateGoogleDriveAuthError, undefined, {}, {}, {}>({
    url: '/google-drive/initiate-oauth',
    method: 'get',
    ...variables,
    signal,
  });

export const useInitiateGoogleDriveAuth = <TData = undefined>(
  variables: InitiateGoogleDriveAuthVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, InitiateGoogleDriveAuthError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, InitiateGoogleDriveAuthError, TData>(
    queryKeyFn({
      path: '/google-drive/initiate-oauth',
      operationId: 'initiateGoogleDriveAuth',
      variables,
    }),
    ({ signal }) =>
      fetchInitiateGoogleDriveAuth({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type HandleGoogleDriveCallbackQueryParams = {
  code: string;
  state: string;
};

export type HandleGoogleDriveCallbackError = Fetcher.ErrorWrapper<undefined>;

export type HandleGoogleDriveCallbackVariables = {
  queryParams: HandleGoogleDriveCallbackQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchHandleGoogleDriveCallback = (
  variables: HandleGoogleDriveCallbackVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    HandleGoogleDriveCallbackError,
    undefined,
    {},
    HandleGoogleDriveCallbackQueryParams,
    {}
  >({
    url: '/google-drive/oauth2callback',
    method: 'get',
    ...variables,
    signal,
  });

export const useHandleGoogleDriveCallback = <TData = undefined>(
  variables: HandleGoogleDriveCallbackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      HandleGoogleDriveCallbackError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, HandleGoogleDriveCallbackError, TData>(
    queryKeyFn({
      path: '/google-drive/oauth2callback',
      operationId: 'handleGoogleDriveCallback',
      variables,
    }),
    ({ signal }) =>
      fetchHandleGoogleDriveCallback(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type GetGoogleDriveConnectionStatusQueryParams = {
  /**
   * The type of service (e.g., "google")
   */
  serviceType: string;
};

export type GetGoogleDriveConnectionStatusError =
  Fetcher.ErrorWrapper<undefined>;

export type GetGoogleDriveConnectionStatusVariables = {
  queryParams: GetGoogleDriveConnectionStatusQueryParams;
} & OpenapiContext['fetcherOptions'];

export const fetchGetGoogleDriveConnectionStatus = (
  variables: GetGoogleDriveConnectionStatusVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    GetGoogleDriveConnectionStatusError,
    undefined,
    {},
    GetGoogleDriveConnectionStatusQueryParams,
    {}
  >({
    url: '/google-drive/connection-status',
    method: 'get',
    ...variables,
    signal,
  });

export const useGetGoogleDriveConnectionStatus = <TData = undefined>(
  variables: GetGoogleDriveConnectionStatusVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      undefined,
      GetGoogleDriveConnectionStatusError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    undefined,
    GetGoogleDriveConnectionStatusError,
    TData
  >(
    queryKeyFn({
      path: '/google-drive/connection-status',
      operationId: 'getGoogleDriveConnectionStatus',
      variables,
    }),
    ({ signal }) =>
      fetchGetGoogleDriveConnectionStatus(
        { ...fetcherOptions, ...variables },
        signal,
      ),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type DeleteGoogleDriveConnectionQueryParams = {
  /**
   * The type of service (e.g., "google")
   */
  serviceType: string;
};

export type DeleteGoogleDriveConnectionError = Fetcher.ErrorWrapper<undefined>;

export type DeleteGoogleDriveConnectionVariables = {
  queryParams: DeleteGoogleDriveConnectionQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * Delete the Google Drive connection for the current organization
 */
export const fetchDeleteGoogleDriveConnection = (
  variables: DeleteGoogleDriveConnectionVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.DeleteGoogleDriveConnectionResponseDto,
    DeleteGoogleDriveConnectionError,
    undefined,
    {},
    DeleteGoogleDriveConnectionQueryParams,
    {}
  >({
    url: '/google-drive/connection',
    method: 'delete',
    ...variables,
    signal,
  });

/**
 * Delete the Google Drive connection for the current organization
 */
export const useDeleteGoogleDriveConnection = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DeleteGoogleDriveConnectionResponseDto,
      DeleteGoogleDriveConnectionError,
      DeleteGoogleDriveConnectionVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    Schemas.DeleteGoogleDriveConnectionResponseDto,
    DeleteGoogleDriveConnectionError,
    DeleteGoogleDriveConnectionVariables
  >(
    (variables: DeleteGoogleDriveConnectionVariables) =>
      fetchDeleteGoogleDriveConnection({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type ListGoogleDrivesQueryParams = {
  serviceType: string;
};

export type ListGoogleDrivesError = Fetcher.ErrorWrapper<undefined>;

export type ListGoogleDrivesVariables = {
  queryParams: ListGoogleDrivesQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * List all available Google Drives including personal and shared drives
 */
export const fetchListGoogleDrives = (
  variables: ListGoogleDrivesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ListGoogleDrivesResponseDto,
    ListGoogleDrivesError,
    undefined,
    {},
    ListGoogleDrivesQueryParams,
    {}
  >({ url: '/google-drive/drives', method: 'get', ...variables, signal });

/**
 * List all available Google Drives including personal and shared drives
 */
export const useListGoogleDrives = <
  TData = Schemas.ListGoogleDrivesResponseDto,
>(
  variables: ListGoogleDrivesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListGoogleDrivesResponseDto,
      ListGoogleDrivesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.ListGoogleDrivesResponseDto,
    ListGoogleDrivesError,
    TData
  >(
    queryKeyFn({
      path: '/google-drive/drives',
      operationId: 'listGoogleDrives',
      variables,
    }),
    ({ signal }) =>
      fetchListGoogleDrives({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type ListGoogleDriveFilesQueryParams = {
  /**
   * The type of service (e.g., "google")
   */
  serviceType: string;
  /**
   * The ID of the user
   */
  userId: string;
  /**
   * The ID of the folder to list files from. Use "root" for root folder.
   */
  folderId?: string;
  /**
   * The ID of the drive to list files from (for shared drives)
   */
  driveId?: string;
  /**
   * Search term to filter files by name
   */
  searchTerm?: string;
  /**
   * Token for pagination
   */
  pageToken?: string;
  /**
   * Number of items per page
   *
   * @default 20
   */
  pageSize?: number;
  /**
   * Sort order for the results
   *
   * @default createdTime desc
   */
  orderBy?: string;
};

export type ListGoogleDriveFilesError = Fetcher.ErrorWrapper<undefined>;

export type ListGoogleDriveFilesVariables = {
  queryParams: ListGoogleDriveFilesQueryParams;
} & OpenapiContext['fetcherOptions'];

/**
 * List files and folders from Google Drive with optional search and pagination
 */
export const fetchListGoogleDriveFiles = (
  variables: ListGoogleDriveFilesVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    Schemas.ListGoogleDriveFilesResponseDto,
    ListGoogleDriveFilesError,
    undefined,
    {},
    ListGoogleDriveFilesQueryParams,
    {}
  >({ url: '/google-drive/files', method: 'get', ...variables, signal });

/**
 * List files and folders from Google Drive with optional search and pagination
 */
export const useListGoogleDriveFiles = <
  TData = Schemas.ListGoogleDriveFilesResponseDto,
>(
  variables: ListGoogleDriveFilesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.ListGoogleDriveFilesResponseDto,
      ListGoogleDriveFilesError,
      TData
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<
    Schemas.ListGoogleDriveFilesResponseDto,
    ListGoogleDriveFilesError,
    TData
  >(
    queryKeyFn({
      path: '/google-drive/files',
      operationId: 'listGoogleDriveFiles',
      variables,
    }),
    ({ signal }) =>
      fetchListGoogleDriveFiles({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type UploadGoogleDriveFilesToOpenAIError =
  Fetcher.ErrorWrapper<undefined>;

export type UploadGoogleDriveFilesToOpenAIVariables = {
  body?: Schemas.UploadGoogleDriveFilesDto;
} & OpenapiContext['fetcherOptions'];

export const fetchUploadGoogleDriveFilesToOpenAI = (
  variables: UploadGoogleDriveFilesToOpenAIVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<
    undefined,
    UploadGoogleDriveFilesToOpenAIError,
    Schemas.UploadGoogleDriveFilesDto,
    {},
    {},
    {}
  >({
    url: '/google-drive/upload-files',
    method: 'post',
    ...variables,
    signal,
  });

export const useUploadGoogleDriveFilesToOpenAI = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UploadGoogleDriveFilesToOpenAIError,
      UploadGoogleDriveFilesToOpenAIVariables
    >,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useOpenapiContext();
  return reactQuery.useMutation<
    undefined,
    UploadGoogleDriveFilesToOpenAIError,
    UploadGoogleDriveFilesToOpenAIVariables
  >(
    (variables: UploadGoogleDriveFilesToOpenAIVariables) =>
      fetchUploadGoogleDriveFilesToOpenAI({ ...fetcherOptions, ...variables }),
    options,
  );
};

export type TestBusinessErrorError = Fetcher.ErrorWrapper<undefined>;

export type TestBusinessErrorVariables = OpenapiContext['fetcherOptions'];

export const fetchTestBusinessError = (
  variables: TestBusinessErrorVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, TestBusinessErrorError, undefined, {}, {}, {}>({
    url: '/test-errors/business-error',
    method: 'get',
    ...variables,
    signal,
  });

export const useTestBusinessError = <TData = undefined>(
  variables: TestBusinessErrorVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, TestBusinessErrorError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, TestBusinessErrorError, TData>(
    queryKeyFn({
      path: '/test-errors/business-error',
      operationId: 'testBusinessError',
      variables,
    }),
    ({ signal }) =>
      fetchTestBusinessError({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type TestUnhandledErrorError = Fetcher.ErrorWrapper<undefined>;

export type TestUnhandledErrorVariables = OpenapiContext['fetcherOptions'];

export const fetchTestUnhandledError = (
  variables: TestUnhandledErrorVariables,
  signal?: AbortSignal,
) =>
  openapiFetch<undefined, TestUnhandledErrorError, undefined, {}, {}, {}>({
    url: '/test-errors/unhandled-error',
    method: 'get',
    ...variables,
    signal,
  });

export const useTestUnhandledError = <TData = undefined>(
  variables: TestUnhandledErrorVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, TestUnhandledErrorError, TData>,
    'queryKey' | 'queryFn'
  >,
) => {
  const { fetcherOptions, queryOptions, queryKeyFn } =
    useOpenapiContext(options);
  return reactQuery.useQuery<undefined, TestUnhandledErrorError, TData>(
    queryKeyFn({
      path: '/test-errors/unhandled-error',
      operationId: 'testUnhandledError',
      variables,
    }),
    ({ signal }) =>
      fetchTestUnhandledError({ ...fetcherOptions, ...variables }, signal),
    {
      ...options,
      ...queryOptions,
    },
  );
};

export type QueryOperation =
  | {
      path: '/health/ishealthy';
      operationId: 'isHealthy';
      variables: IsHealthyVariables;
    }
  | {
      path: '/workspaces/{id}';
      operationId: 'workspaceDetails';
      variables: WorkspaceDetailsVariables;
    }
  | {
      path: '/workspaces/{workspaceId}/members';
      operationId: 'getWorkspaceMembers';
      variables: GetWorkspaceMembersVariables;
    }
  | {
      path: '/workspaces';
      operationId: 'getWorkspaces';
      variables: GetWorkspacesVariables;
    }
  | {
      path: '/workspaces/{workspaceId}/invitations/invitations';
      operationId: 'getInvitations';
      variables: GetInvitationsVariables;
    }
  | {
      path: '/invitations/details';
      operationId: 'getInvitationDetails';
      variables: GetInvitationDetailsVariables;
    }
  | {
      path: '/public/search';
      operationId: 'publicSearch';
      variables: PublicSearchVariables;
    }
  | {
      path: '/procs/{id}';
      operationId: 'procDetails';
      variables: ProcDetailsVariables;
    }
  | {
      path: '/public/procs/{id}';
      operationId: 'procPublicDetails';
      variables: ProcPublicDetailsVariables;
    }
  | {
      path: '/procs/workspaces/{workspaceId}';
      operationId: 'getProcsByWorkspace';
      variables: GetProcsByWorkspaceVariables;
    }
  | {
      path: '/procs/instances/{instanceId}';
      operationId: 'getOneProcInstanceAuthorView';
      variables: GetOneProcInstanceAuthorViewVariables;
    }
  | {
      path: '/procs/{procId}/instances';
      operationId: 'procInstances';
      variables: ProcInstancesVariables;
    }
  | {
      path: '/procs/author/instances/{instanceId}';
      operationId: 'getProcInstance';
      variables: GetProcInstanceVariables;
    }
  | {
      path: '/procs/instances/list/my';
      operationId: 'getInstancesForCurrentUser';
      variables: GetInstancesForCurrentUserVariables;
    }
  | {
      path: '/procs/type/{procType}/{id}';
      operationId: 'details';
      variables: DetailsVariables;
    }
  | {
      path: '/instances/{id}';
      operationId: 'procInstanceDetails';
      variables: ProcInstanceDetailsVariables;
    }
  | {
      path: '/procs/{procId}/logics';
      operationId: 'getLogicsByProcId';
      variables: GetLogicsByProcIdVariables;
    }
  | {
      path: '/instances/{instanceId}/threads/{threadId}/messages';
      operationId: 'getInstanceStepAiMessages';
      variables: GetInstanceStepAiMessagesVariables;
    }
  | {
      path: '/notifications/instances/{viewType}/{instanceId}';
      operationId: 'getNotificationsForInstance';
      variables: GetNotificationsForInstanceVariables;
    }
  | {
      path: '/notifications/instance/{viewType}/{instanceId}/info';
      operationId: 'getNotificationsInfoForInstance';
      variables: GetNotificationsInfoForInstanceVariables;
    }
  | {
      path: '/notifications/{organizationId}';
      operationId: 'getAllUserNotifications';
      variables: GetAllUserNotificationsVariables;
    }
  | {
      path: '/notifications/{organizationId}/info';
      operationId: 'getNotificationInfo';
      variables: GetNotificationInfoVariables;
    }
  | {
      path: '/user-account/organization/{organizationId}/plan-usage';
      operationId: 'getPlanUsage';
      variables: GetPlanUsageVariables;
    }
  | {
      path: '/plans';
      operationId: 'getPlans';
      variables: GetPlansVariables;
    }
  | {
      path: '/plans/{planType}/interval/{interval}/organization/{organizationId}';
      operationId: 'handleSubscription';
      variables: HandleSubscriptionVariables;
    }
  | {
      path: '/plans/{planType}/interval/{interval}/organization/{organizationId}/preview';
      operationId: 'getSubscriptionPriceChangePreview';
      variables: GetSubscriptionPriceChangePreviewVariables;
    }
  | {
      path: '/organizations/{id}';
      operationId: 'getOrganizationMemberships';
      variables: GetOrganizationMembershipsVariables;
    }
  | {
      path: '/organizations/{id}/invite';
      operationId: 'getOrganizationInvitations';
      variables: GetOrganizationInvitationsVariables;
    }
  | {
      path: '/organizations/invitation/details';
      operationId: 'getOrgInvitationByTokenId';
      variables: GetOrgInvitationByTokenIdVariables;
    }
  | {
      path: '/organizations/{id}/ai-assistant';
      operationId: 'getAiAssistant';
      variables: GetAiAssistantVariables;
    }
  | {
      path: '/organizations/{id}/ai-assistant/files';
      operationId: 'getAiAssistantFiles';
      variables: GetAiAssistantFilesVariables;
    }
  | {
      path: '/public/organizations/procs';
      operationId: 'getOrganizationsSharedProcs';
      variables: GetOrganizationsSharedProcsVariables;
    }
  | {
      path: '/public/organizations/{shareCode}';
      operationId: 'getOrganizationByShareCode';
      variables: GetOrganizationByShareCodeVariables;
    }
  | {
      path: '/public/organizations/threads/{threadId}/messages';
      operationId: 'getOrgAiMessages';
      variables: GetOrgAiMessagesVariables;
    }
  | {
      path: '/accounts/my-profile';
      operationId: 'getMyAccount';
      variables: GetMyAccountVariables;
    }
  | {
      path: '/media-assets/files';
      operationId: 'getMediaAssets';
      variables: GetMediaAssetsVariables;
    }
  | {
      path: '/files/organization/{organizationId}';
      operationId: 'getOrganizationFiles';
      variables: GetOrganizationFilesVariables;
    }
  | {
      path: '/file-labels/organization/{organizationId}';
      operationId: 'getOrganizationLabels';
      variables: GetOrganizationLabelsVariables;
    }
  | {
      path: '/file-labels/{id}';
      operationId: 'getLabelById';
      variables: GetLabelByIdVariables;
    }
  | {
      path: '/instances/{instanceId}/step/{stepId}/comments';
      operationId: 'commentGetAll';
      variables: CommentGetAllVariables;
    }
  | {
      path: '/welcome-back';
      operationId: 'trackLogin';
      variables: TrackLoginVariables;
    }
  | {
      path: '/confluence/initiate-oauth';
      operationId: 'initiateConfluenceAuth';
      variables: InitiateConfluenceAuthVariables;
    }
  | {
      path: '/confluence/oauth2callback';
      operationId: 'handleConfluenceCallback';
      variables: HandleConfluenceCallbackVariables;
    }
  | {
      path: '/confluence/connection-status';
      operationId: 'getConfluenceConnectionStatus';
      variables: GetConfluenceConnectionStatusVariables;
    }
  | {
      path: '/confluence/sites';
      operationId: 'listConfluenceSites';
      variables: ListConfluenceSitesVariables;
    }
  | {
      path: '/confluence/spaces';
      operationId: 'listConfluenceSiteSpaces';
      variables: ListConfluenceSiteSpacesVariables;
    }
  | {
      path: '/confluence/pages';
      operationId: 'listConfluenceSpacePages';
      variables: ListConfluenceSpacePagesVariables;
    }
  | {
      path: '/confluence/content';
      operationId: 'listConfluencePageContent';
      variables: ListConfluencePageContentVariables;
    }
  | {
      path: '/google-drive/initiate-oauth';
      operationId: 'initiateGoogleDriveAuth';
      variables: InitiateGoogleDriveAuthVariables;
    }
  | {
      path: '/google-drive/oauth2callback';
      operationId: 'handleGoogleDriveCallback';
      variables: HandleGoogleDriveCallbackVariables;
    }
  | {
      path: '/google-drive/connection-status';
      operationId: 'getGoogleDriveConnectionStatus';
      variables: GetGoogleDriveConnectionStatusVariables;
    }
  | {
      path: '/google-drive/drives';
      operationId: 'listGoogleDrives';
      variables: ListGoogleDrivesVariables;
    }
  | {
      path: '/google-drive/files';
      operationId: 'listGoogleDriveFiles';
      variables: ListGoogleDriveFilesVariables;
    }
  | {
      path: '/test-errors/business-error';
      operationId: 'testBusinessError';
      variables: TestBusinessErrorVariables;
    }
  | {
      path: '/test-errors/unhandled-error';
      operationId: 'testUnhandledError';
      variables: TestUnhandledErrorVariables;
    };
